import React, { CSSProperties } from 'react';
import { colors } from './colors';

export type CustomizableIconType =
  | 'feed'
  | 'dumbbell'
  | 'dumbbell-flat'
  | 'dumbbell-big'
  | 'profile'
  | 'settings'
  | 'logout'
  | 'profile-large'
  | 'lock'
  | 'lock-light'
  | 'pro'
  | 'ruler'
  | 'export'
  | 'moon'
  | 'chevron-right'
  | 'chevron-left'
  | 'routine'
  | 'routine-navbar'
  | 'new-folder'
  | 'folder-solid'
  | 'folder-small'
  | 'camera'
  | 'bicep'
  | 'micro-dumbbell'
  | 'folder'
  | 'plus'
  | 'plus-small'
  | 'barbell'
  | 'check'
  | 'check-circle'
  | 'cross'
  | 'measure'
  | 'body'
  | 'pr'
  | 'arrow-up'
  | 'arrow-down'
  | 'arrow-right'
  | 'envelope'
  | 'trash'
  | 'search-cross'
  | 'credit-card'
  | 'search'
  | 'star'
  | 'warning-triangle'
  | 'email'
  | 'question-circle'
  | 'paper-airplane'
  | 'like'
  | 'like-filled'
  | 'share'
  | 'menu'
  | 'video'
  | 'link'
  | 'chevron-down'
  | 'program'
  | 'wifi-off'
  | 'reorder'
  | 'assign'
  | 'send'
  | 'expand'
  | 'new-chat'
  | 'chats'
  | 'message'
  | 'clients'
  | 'image-plus'
  | 'activity'
  | 'empty-graph'
  | 'duration-graph'
  | 'volume-graph'
  | 'sets-graph'
  | 'sets-per-muscle-group-graph'
  | 'clock'
  | 'calendar'
  | 'notepad'
  | 'template'
  | 'comment'
  | 'sort-arrow'
  | 'spider-web'
  | 'muscle-group-body'
  | 'routine-summary-button'
  | 'program-summary-toggle'
  | 'import'
  | 'transfer-to-coach'
  | 'transfer-from-coach'
  | 'team'
  | 'brush'
  | 'external-link'
  | 'cross-small'
  | 'compare'
  | 'picture-frame'
  | 'notification'
  | 'users'
  | 'picture-plus';

interface CustomizableIconProps {
  type: CustomizableIconType;
  tint: string;
  style?: CSSProperties;
  height?: number;
  width?: number;
}

export const CustomizableIcon = (props: CustomizableIconProps) => {
  switch (props.type) {
    case 'feed':
      return <SvgFeed {...props} />;
    case 'dumbbell':
      return <SvgDumbbell {...props} />;
    case 'dumbbell-flat':
      return <SvgDumbbellFlat {...props} />;
    case 'dumbbell-big':
      return <SvgDumbbellBig {...props} />;
    case 'profile':
      return <SvgProfile {...props} />;
    case 'settings':
      return <SvgSettings {...props} />;
    case 'logout':
      return <SvgLogout {...props} />;
    case 'profile-large':
      return <SvgProfileLarge {...props} />;
    case 'lock':
      return <SvgLock {...props} />;
    case 'lock-light':
      return <SvgLockLight {...props} />;
    case 'pro':
      return <SvgPro {...props} />;
    case 'ruler':
      return <SvgRuler {...props} />;
    case 'export':
      return <SvgExport {...props} />;
    case 'moon':
      return <SvgMoon {...props} />;
    case 'chevron-right':
      return <SvgChevronRight {...props} />;
    case 'chevron-left':
      return <SvgChevronLeft {...props} />;
    case 'routine':
      return <SvgRoutine {...props} />;
    case 'routine-navbar':
      return <SvgRoutineNavBar {...props} />;
    case 'new-folder':
      return <SvgNewFolder {...props} />;
    case 'folder-solid':
      return <SvgFolderSolid {...props} />;
    case 'folder-small':
      return <SvgFolderSmall {...props} />;
    case 'camera':
      return <SvgCamera {...props} />;
    case 'bicep':
      return <SvgBicep {...props} />;
    case 'micro-dumbbell':
      return <SvgMicroDumbbell {...props} />;
    case 'folder':
      return <SvgFolder {...props} style={{ ...props.style, stroke: props.tint }} />;
    case 'plus':
      return <SvgPlus {...props} style={{ ...props.style, stroke: props.tint }} />;
    case 'plus-small':
      return <SvgPlusSmall {...props} style={{ ...props.style, stroke: props.tint }} />;
    case 'barbell':
      return <SvgBarbell {...props} />;
    case 'cross':
      return <SvgCross {...props} />;
    case 'check':
      return <SvgCheck {...props} />;
    case 'check-circle':
      return <SvgCheckCircle {...props} />;
    case 'measure':
      return <SvgMeasure {...props} />;
    case 'body':
      return <SvgBody {...props} />;
    case 'pr':
      return <SvgPr {...props} />;
    case 'arrow-up':
      return <SvgArrowUp {...props} />;
    case 'arrow-down':
      return <SvgArrowDown {...props} />;
    case 'arrow-right':
      return <SvgArrowRight {...props} />;
    case 'envelope':
      return <SvgEnvelope {...props} />;
    case 'trash':
      return <SvgTrash {...props} />;
    case 'search-cross':
      return <SvgSearchCross {...props} />;
    case 'credit-card':
      return <SvgCreditCard {...props} />;
    case 'search':
      return <SvgSearch {...props} />;
    case 'email':
      return <SvgEmail {...props} />;
    case 'star':
      return <SvgStar {...props} />;
    case 'warning-triangle':
      return <SvgWarningTriangle {...props} />;
    case 'question-circle':
      return <SvgQuestionCircle {...props} />;
    case 'paper-airplane':
      return <SvgPaperAirplane {...props} />;
    case 'like':
      return <SvgLike {...props} />;
    case 'like-filled':
      return <SvgLikeFilled {...props} />;
    case 'share':
      return <SvgShare {...props} />;
    case 'menu':
      return <SvgMenu {...props} />;
    case 'video':
      return <SvgVideo {...props} />;
    case 'link':
      return <SvgLink {...props} />;
    case 'chevron-down':
      return <SvgChevronDown {...props} />;
    case 'wifi-off':
      return <SvgWifiOff {...props} />;
    case 'program':
      return <SvgProgram {...props} />;
    case 'reorder':
      return <SvgReorder {...props} />;
    case 'assign':
      return <SvgAssign {...props} />;
    case 'send':
      return <SvgSend {...props} />;
    case 'expand':
      return <SvgExpand {...props} />;
    case 'new-chat':
      return <SvgNewChat {...props} />;
    case 'chats':
      return <SvgChats {...props} />;
    case 'message':
      return <SvgMessage {...props} />;
    case 'clients':
      return <SvgClients {...props} />;
    case 'image-plus':
      return <SvgImagePlus {...props} />;
    case 'activity':
      return <SvgActivity {...props} />;
    case 'empty-graph':
      return <SvgEmptyGraph {...props} />;
    case 'duration-graph':
      return <SvgDurationGraph {...props} />;
    case 'volume-graph':
      return <SvgVolumeGraph {...props} />;
    case 'sets-graph':
      return <SvgSetsGraph {...props} />;
    case 'sets-per-muscle-group-graph':
      return <SvgSetsPerMuscleGroupGraph {...props} />;
    case 'clock':
      return <SvgClock {...props} />;
    case 'calendar':
      return <SvgCalendar {...props} />;
    case 'notepad':
      return <SvgNotepad {...props} />;
    case 'template':
      return <SvgTemplate {...props} />;
    case 'comment':
      return <SvgComment {...props} />;
    case 'sort-arrow':
      return <SvgSortArrow {...props} />;
    case 'spider-web':
      return <SvgSpiderWeb {...props} />;
    case 'muscle-group-body':
      return <SvgMuscleGroupBody {...props} />;
    case 'routine-summary-button':
      return <SvgRoutineSummaryButtonIcon {...props} />;
    case 'program-summary-toggle':
      return <SvgProgramSummaryToggle {...props} />;
    case 'import':
      return <SvgImport {...props} />;
    case 'transfer-to-coach':
      return <SvgTransferToCoach {...props} />;
    case 'transfer-from-coach':
      return <SvgTransferFromCoach {...props} />;
    case 'team':
      return <SvgTeam {...props} />;
    case 'cross-small':
      return <SvgCrossSmall {...props} />;
    case 'notification':
      return <SvgNotification {...props} />;
    case 'users':
      return <SvgUsers {...props} />;
    case 'compare':
      return <SvgCompare {...props} />;
    case 'picture-frame':
      return <SvgPictureFrame {...props} />;
    case 'brush':
      return <SvgBrush {...props} />;
    case 'external-link':
      return <SvgExternalLink {...props} />;
    case 'picture-plus':
      return <SvgPicturePlus {...props} />;
  }
};

interface SvgProps {
  tint: string;
  style?: CSSProperties;
  width?: number;
  height?: number;
}

function SvgWarningTriangle(props: SvgProps) {
  return (
    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99817 6.50019V9.83353M9.99817 13.1669H10.0065M8.84427 2.24329L1.99019 14.0821C1.61002 14.7388 1.41994 15.0671 1.44803 15.3366C1.47254 15.5716 1.59568 15.7852 1.78681 15.9242C2.00594 16.0835 2.38533 16.0835 3.1441 16.0835H16.8522C17.611 16.0835 17.9904 16.0835 18.2095 15.9242C18.4007 15.7852 18.5238 15.5716 18.5483 15.3366C18.5764 15.0671 18.3863 14.7388 18.0061 14.0821L11.1521 2.24329C10.7733 1.58899 10.5839 1.26184 10.3368 1.15196C10.1212 1.05612 9.87513 1.05612 9.65959 1.15196C9.41248 1.26184 9.22307 1.58899 8.84427 2.24329Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgStar(props: SvgProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3231 1.41541L12.9328 6.70315C12.9757 6.79014 13.0587 6.85045 13.1547 6.8644L18.9901 7.71233C19.2319 7.74745 19.3284 8.04456 19.1535 8.21508L14.9309 12.331C14.8615 12.3987 14.8298 12.4963 14.8462 12.5919L15.843 18.4037C15.8843 18.6445 15.6315 18.8281 15.4153 18.7144L10.196 15.9705C10.1101 15.9253 10.0075 15.9253 9.92166 15.9705L4.70236 18.7144C4.48611 18.8281 4.23339 18.6445 4.27469 18.4037L5.27148 12.5919C5.28788 12.4963 5.25618 12.3987 5.18671 12.331L0.964202 8.21508C0.789261 8.04456 0.885777 7.74745 1.12754 7.71233L6.96292 6.8644C7.05893 6.85045 7.14192 6.79014 7.18484 6.70315L9.7945 1.41541C9.90263 1.19633 10.215 1.19633 10.3231 1.41541Z"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgCreditCard(props: SvgProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3334 8.33335H1.66675M9.16675 11.6667H5.00008M1.66675 6.83335L1.66675 13.1667C1.66675 14.1001 1.66675 14.5668 1.8484 14.9233C2.00819 15.2369 2.26316 15.4919 2.57676 15.6517C2.93328 15.8334 3.39999 15.8334 4.33341 15.8334L15.6667 15.8334C16.6002 15.8334 17.0669 15.8334 17.4234 15.6517C17.737 15.4919 17.992 15.2369 18.1518 14.9233C18.3334 14.5668 18.3334 14.1001 18.3334 13.1667V6.83335C18.3334 5.89993 18.3334 5.43322 18.1518 5.0767C17.992 4.7631 17.737 4.50813 17.4234 4.34834C17.0669 4.16669 16.6002 4.16669 15.6667 4.16669L4.33342 4.16669C3.39999 4.16669 2.93328 4.16669 2.57676 4.34834C2.26316 4.50813 2.00819 4.7631 1.8484 5.0767C1.66675 5.43322 1.66675 5.89993 1.66675 6.83335Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgTrash(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2 5.2V4.56C13.2 3.66392 13.2 3.21587 13.0257 2.87362C12.8723 2.57256 12.6275 2.32779 12.3264 2.17439C11.9842 2 11.5361 2 10.64 2H9.36005C8.46396 2 8.01592 2 7.67366 2.17439C7.3726 2.32779 7.12784 2.57256 6.97444 2.87362C6.80005 3.21587 6.80005 3.66392 6.80005 4.56V5.2M8.40005 9.6V13.6M11.6 9.6V13.6M2.80005 5.2H17.2M15.6 5.2V14.16C15.6 15.5041 15.6 16.1762 15.3385 16.6896C15.1084 17.1412 14.7412 17.5083 14.2896 17.7384C13.7762 18 13.1042 18 11.76 18H8.24005C6.89592 18 6.22386 18 5.71047 17.7384C5.25888 17.5083 4.89173 17.1412 4.66163 16.6896C4.40005 16.1762 4.40005 15.5041 4.40005 14.16V5.2"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgEnvelope(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.125 14.5L12.1429 10M7.85714 10L2.87503 14.5M2.5 6.25L8.62369 10.5366C9.11957 10.8837 9.36751 11.0573 9.6372 11.1245C9.87542 11.1839 10.1246 11.1839 10.3628 11.1245C10.6325 11.0573 10.8804 10.8837 11.3763 10.5366L17.5 6.25M6.1 16H13.9C15.1601 16 15.7902 16 16.2715 15.7548C16.6948 15.539 17.0391 15.1948 17.2548 14.7715C17.5 14.2902 17.5 13.6601 17.5 12.4V7.6C17.5 6.33988 17.5 5.70982 17.2548 5.22852C17.0391 4.80516 16.6948 4.46095 16.2715 4.24524C15.7902 4 15.1601 4 13.9 4H6.1C4.83988 4 4.20982 4 3.72852 4.24524C3.30516 4.46095 2.96095 4.80516 2.74524 5.22852C2.5 5.70982 2.5 6.33988 2.5 7.6V12.4C2.5 13.6601 2.5 14.2902 2.74524 14.7715C2.96095 15.1948 3.30516 15.539 3.72852 15.7548C4.20982 16 4.83988 16 6.1 16Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgSettings(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2741_20092)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.58301 0.749023C8.22549 0.749023 7.91767 1.00139 7.84757 1.35198L7.50258 3.07738C7.2871 3.15453 7.07564 3.24141 6.86902 3.33808L5.40684 2.36335C5.10938 2.16505 4.71331 2.20427 4.46051 2.45705L2.45667 4.46079C2.20385 4.71359 2.16463 5.1097 2.36296 5.40717L3.3378 6.86936C3.24117 7.07599 3.15436 7.28734 3.07721 7.50267L1.3515 7.84768C1.00091 7.91778 0.748535 8.2256 0.748535 8.58313V11.4168C0.748535 11.7743 1.00091 12.0821 1.3515 12.1522L3.07702 12.4972C3.15417 12.7126 3.24105 12.9241 3.33772 13.1307L2.36296 14.5927C2.16463 14.8902 2.20385 15.2863 2.45667 15.5391L4.46051 17.5429C4.71331 17.7956 5.10938 17.8349 5.40684 17.6366L6.86914 16.6617C7.0758 16.7584 7.28718 16.8452 7.50255 16.9223L7.84757 18.6479C7.91767 18.9985 8.22549 19.2509 8.58301 19.2509H11.4168C11.7743 19.2509 12.0822 18.9985 12.1522 18.6479L12.4972 16.9225C12.7127 16.8454 12.9242 16.7585 13.1308 16.6618L14.593 17.6366C14.8904 17.8349 15.2865 17.7956 15.5393 17.5429L17.5432 15.5391C17.796 15.2863 17.8352 14.8902 17.6369 14.5927L16.662 13.1305C16.7587 12.9239 16.8455 12.7126 16.9226 12.4972L18.6483 12.1522C18.9989 12.0821 19.2513 11.7743 19.2513 11.4168V8.58313C19.2513 8.2256 18.9989 7.91778 18.6483 7.84768L16.9228 7.50271C16.8456 7.28726 16.7588 7.07583 16.6621 6.86924L17.6369 5.40717C17.8352 5.1097 17.796 4.71359 17.5432 4.46079L15.5393 2.45705C15.2865 2.20427 14.8904 2.16505 14.593 2.36335L13.1307 3.33816C12.924 3.24153 12.7126 3.15472 12.4973 3.07757L12.1522 1.35198C12.0822 1.00139 11.7743 0.749023 11.4168 0.749023H8.58301ZM8.88737 3.80212L9.1979 2.24902H10.8019L11.1125 3.80212C11.1672 4.07611 11.3698 4.29694 11.6381 4.37512C12.0561 4.49695 12.4523 4.65953 12.8207 4.86224C13.0658 4.9971 13.3655 4.98436 13.5983 4.8292L14.9134 3.95247L16.0477 5.0867L15.171 6.40173C15.0157 6.63458 15.0031 6.93448 15.1381 7.17961C15.3408 7.54763 15.5036 7.94392 15.6249 8.36142C15.703 8.62991 15.9239 8.8327 16.1981 8.88751L17.7513 9.19803V10.8019L16.1981 11.1124C15.9241 11.1672 15.7033 11.3697 15.6251 11.638C15.5032 12.056 15.3407 12.4522 15.1379 12.8205C15.0031 13.0656 15.0158 13.3654 15.171 13.5982L16.0477 14.9132L14.9134 16.0474L13.5983 15.1707C13.3654 15.0155 13.0656 15.0028 12.8204 15.1378C12.4524 15.3405 12.0561 15.5033 11.6386 15.6246C11.3701 15.7027 11.1673 15.9236 11.1125 16.1978L10.8019 17.7509H9.1979L8.88737 16.1978C8.83258 15.9238 8.63003 15.703 8.36177 15.6248C7.9437 15.503 7.54752 15.3404 7.17914 15.1377C6.93406 15.0028 6.6343 15.0155 6.40155 15.1707L5.08639 16.0474L3.9521 14.9132L4.82883 13.5982C4.98407 13.3653 4.99676 13.0654 4.86175 12.8203C4.65905 12.4523 4.49625 12.056 4.37488 11.6385C4.29683 11.37 4.07591 11.1672 3.80173 11.1124L2.24854 10.8019V9.19803L3.80173 8.88751C4.07572 8.83273 4.29655 8.63018 4.37474 8.36193C4.49658 7.94389 4.65916 7.54774 4.86188 7.17937C4.99676 6.93428 4.98402 6.6345 4.82883 6.40173L3.9521 5.0867L5.08639 3.95247L6.40155 4.8292C6.63438 4.98441 6.93426 4.9971 7.17937 4.86211C7.54741 4.65942 7.94373 4.49663 8.36126 4.37526C8.62976 4.29722 8.83255 4.0763 8.88737 3.80212ZM7.91587 10.0001C7.91587 8.84954 8.84892 7.91648 9.99966 7.91648C11.1504 7.91648 12.0835 8.84954 12.0835 10.0001C12.0835 11.151 11.1505 12.0838 9.99966 12.0838C8.84892 12.0838 7.91587 11.1507 7.91587 10.0001ZM9.99966 6.41648C8.02057 6.41648 6.41587 8.02104 6.41587 10.0001C6.41587 11.9792 8.02057 13.5838 9.99966 13.5838C11.9787 13.5838 13.5835 11.9796 13.5835 10.0001C13.5835 8.02104 11.9788 6.41648 9.99966 6.41648Z"
          fill={props.tint}
        />
      </g>
      <defs>
        <clipPath id="clip0_2741_20092">
          <rect width="20" height="20" fill={props.tint} />
        </clipPath>
      </defs>
    </svg>
  );
}

function SvgLogout(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill={props.tint} fillRule="nonzero" stroke={props.tint} strokeWidth={0.3}>
        <path d="M14.655 21.033H8.914a.638.638 0 01-.638-.638V8.914c0-.352.286-.638.638-.638h5.74a.637.637 0 100-1.276h-5.74A1.916 1.916 0 007 8.914v11.481c0 1.055.859 1.914 1.914 1.914h5.74a.637.637 0 100-1.276z" />
        <path d="M22.17 14.2l-3.878-3.827a.638.638 0 10-.896.908l2.772 2.736H12.74a.637.637 0 100 1.275h7.427l-2.772 2.736a.638.638 0 10.896.908l3.878-3.827a.64.64 0 000-.909z" />
      </g>
    </svg>
  );
}

function SvgFeed(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke={props.tint} strokeWidth={1.2} fill="none" fillRule="evenodd">
        <path d="M10 21.65v-7.026l5.576-5.474 5.576 5.474v7.026h-4.086v-3.536c0-.559-.28-1.08-.745-1.39l-.007-.005a1.323 1.323 0 00-1.473.005c-.46.31-.734.828-.734 1.382v3.544h0H10z" />
        <path d="M8 16.362L15.5 9l7.5 7.362" />
      </g>
    </svg>
  );
}

function SvgDumbbell(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5668 3.46056L10.1456 4.88174C9.88397 5.14337 9.89271 5.5763 10.1651 5.84871L18.057 13.7406C18.3294 14.013 18.7623 14.0217 19.0239 13.7601L20.4451 12.3389C20.7067 12.0773 20.698 11.6443 20.4256 11.3719L12.5337 3.48008C12.2613 3.20767 11.8284 3.19893 11.5668 3.46056Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3387 20.4437L13.7599 19.0226C14.0215 18.7609 14.0128 18.328 13.7404 18.0556L5.84856 10.1637C5.57615 9.89133 5.14322 9.8826 4.88159 10.1442L3.46041 11.5654C3.19878 11.827 3.20752 12.26 3.47993 12.5324L11.3718 20.4242C11.6442 20.6966 12.0771 20.7054 12.3387 20.4437Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6172 4.36865L15.3937 2.59218C15.5507 2.43513 15.7533 2.33648 15.9568 2.31793C16.1604 2.29938 16.3482 2.36245 16.4791 2.49326L21.4115 7.42566C21.5423 7.55648 21.6053 7.74433 21.5868 7.94788C21.5682 8.15143 21.4696 8.35401 21.3125 8.51106L19.5361 10.2875"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2883 19.5356L8.51186 21.3121C8.35481 21.4692 8.15222 21.5678 7.94867 21.5864C7.74512 21.6049 7.55727 21.5418 7.42646 21.411L2.49406 16.4786C2.36324 16.3478 2.30017 16.16 2.31872 15.9564C2.33727 15.7529 2.43593 15.5503 2.59298 15.3932L4.36945 13.6168"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14L14 10"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgProfile(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        transform="translate(9 8)"
        stroke={props.tint}
        strokeWidth={1.2}
        fill="none"
        fillRule="evenodd"
      >
        <path d="M6.24 7.533c1.52 0 2.9.602 3.914 1.58a5.626 5.626 0 011.667 3.243h0l-11.188.206a5.623 5.623 0 011.619-3.377A5.622 5.622 0 016.24 7.533z" />
        <circle cx={6.24} cy={2.773} r={2.773} />
      </g>
    </svg>
  );
}

function SvgProfileLarge(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd" stroke={props.tint} strokeWidth={1.5}>
        <path d="M15 16.75c2.234 0 4.26.888 5.746 2.33a8.227 8.227 0 012.444 4.916h0l-16.405.242a8.224 8.224 0 012.381-5.072A8.224 8.224 0 0115 16.75z" />
        <circle cx={15} cy={10} r={4} />
      </g>
    </svg>
  );
}

function SvgLock(props: SvgProps) {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.3057 15.2H10.6945C11.0833 15.2 11.4001 14.8818 11.4001 14.4913V7.6348C11.4001 7.24425 11.0833 6.92602 10.6945 6.92602H9.9889V4.80688C9.9889 2.59372 8.1961 0.800049 6.0001 0.800049C3.8041 0.800049 2.0113 2.60095 2.0113 4.80688V6.92602H1.3057C0.916898 6.92602 0.600098 7.24425 0.600098 7.6348V14.4913C0.600098 14.8818 0.916898 15.2 1.3057 15.2ZM3.4153 4.80688C3.4153 3.37484 4.5745 2.2104 6.0001 2.2104C7.4257 2.2104 8.5849 3.37484 8.5849 4.80688V6.92602H3.4153V4.80688Z"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgCross(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 5L10 10M10 10L15 15M10 10L5 15M10 10L15 5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgPro(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <text
        fill={props.tint}
        fillRule="evenodd"
        fontFamily="AvenirNext-DemiBold, Avenir Next"
        fontSize={12.756}
        fontWeight={500}
        letterSpacing={-0.138}
      >
        <tspan x={1.889} y={19}>
          {'PRO'}
        </tspan>
      </text>
    </svg>
  );
}

function SvgRuler(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        transform="rotate(-45 28.692 4.672)"
        stroke={props.tint}
        strokeWidth={1.65}
        fill="none"
        fillRule="evenodd"
      >
        <rect width={22} height={5.5} rx={1.1} />
        <path
          strokeLinecap="round"
          d="M4.499.327v1.729M8.899.327v1.729M13.299.327v1.729M17.699.327v1.729"
        />
      </g>
    </svg>
  );
}

function SvgExport(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill={props.tint} fillRule="nonzero" stroke={props.tint} strokeWidth={0.65}>
        <path d="M24.524 6h-4.743a.474.474 0 00-.475.472c0 .26.213.471.475.471h3.602l-9.253 9.261a.469.469 0 00.01.66c.184.18.48.182.665.004l9.244-9.25v3.555c0 .261.213.472.475.472a.474.474 0 00.476-.472V6.472A.474.474 0 0024.524 6z" />
        <path d="M21.521 16.883a.479.479 0 00-.479.479v5.244c0 .793-.643 1.435-1.436 1.436H8.394a1.438 1.438 0 01-1.436-1.436V11.394c0-.793.643-1.435 1.436-1.436h5.244a.479.479 0 100-.958H8.394A2.397 2.397 0 006 11.394v11.212A2.397 2.397 0 008.394 25h11.212A2.397 2.397 0 0022 22.606v-5.244a.479.479 0 00-.479-.479z" />
      </g>
    </svg>
  );
}

function SvgMoon(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.55 4.001c.418-.019.709.167.87.557.172.39.1.733-.214 1.028a7.594 7.594 0 00-1.877 2.59 7.669 7.669 0 00-.65 3.12c0 1.409.348 2.708 1.042 3.897a7.74 7.74 0 002.827 2.827 7.589 7.589 0 003.897 1.042 7.655 7.655 0 003.255-.728c.39-.172.732-.11 1.027.186a.886.886 0 01.25.485c.034.19.012.37-.064.542a10.78 10.78 0 01-4.047 4.632 10.721 10.721 0 01-5.903 1.735c-1.484 0-2.902-.29-4.253-.87-1.352-.582-2.518-1.362-3.498-2.342-.98-.98-1.76-2.146-2.341-3.497C5.29 17.853 5 16.435 5 14.95c0-1.456.274-2.847.82-4.175.548-1.328 1.29-2.477 2.228-3.448.937-.97 2.058-1.753 3.362-2.348a10.91 10.91 0 014.14-.978zm-.054.77c-.46-.342-1.517.138-2.442.414-2.121.634-3.86 1.898-5.205 3.681-1.347 1.786-2.022 3.813-2.022 6.085 0 1.375.27 2.689.81 3.942a10.221 10.221 0 002.16 3.224 10.214 10.214 0 003.224 2.16c1.253.54 2.567.81 3.942.81a9.974 9.974 0 004.334-.975c1.366-.649 2.56-1.514 3.52-2.675.96-1.16 1.672-1.632 1.324-2.164-.349-.533-1.792.298-2.267.43a5.3 5.3 0 01-1.43.186 8.43 8.43 0 01-4.308-1.15 8.504 8.504 0 01-3.134-3.134 8.432 8.432 0 01-1.15-4.309c0-1.636.444-3.157 1.33-4.563.466-.738 1.775-1.622 1.314-1.963z"
        stroke={props.tint}
        strokeWidth={0.6}
        fill={props.tint}
        fillRule="nonzero"
      />
    </svg>
  );
}

function SvgChevronRight(props: SvgProps) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 12L6.5 7L1.5 2"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgChevronLeft(props: SvgProps) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.5 2L1.5 7L6.5 12"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgRoutine(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        transform="translate(8.5 3.8)"
        stroke={props.tint}
        strokeWidth={1.5}
        fill="none"
        fillRule="evenodd"
      >
        <rect y={5.689} width={13} height={15} rx={0.941} />
        <path d="M4.68 2.76h.054a1.913 1.913 0 013.26-.178l.123.177h.163c.95 0 1.72.77 1.72 1.72h0v1.21H3v-1.25c0-.928.752-1.68 1.68-1.68z" />
        <path strokeLinecap="round" d="M3 11.189h7M3 15.689h7" />
      </g>
    </svg>
  );
}

function SvgRoutineNavBar(props: SvgProps) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        transform="translate(8.5 3.8)"
        stroke={props.tint}
        strokeWidth={1.5}
        fill="none"
        fillRule="evenodd"
      >
        <rect y={5.689} width={13} height={15} rx={0.941} />
        <path d="M4.68 2.76h.054a1.913 1.913 0 013.26-.178l.123.177h.163c.95 0 1.72.77 1.72 1.72h0v1.21H3v-1.25c0-.928.752-1.68 1.68-1.68z" />
        <path strokeLinecap="round" d="M3 11.189h7M3 15.689h7" />
      </g>
    </svg>
  );
}

function SvgFolder(props: SvgProps) {
  return (
    <svg
      width={`${props.width ?? 26}`}
      height={`${props.height ?? 24}`}
      viewBox={`0 0 ${props.width ?? 26} ${props.height ?? 24}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1875 6.09722L12.8628 3.4633C12.4815 2.70525 12.2909 2.32621 12.0065 2.04929C11.755 1.8044 11.4519 1.61816 11.1191 1.50405C10.7428 1.375 10.3165 1.375 9.46397 1.375H4.925C3.59488 1.375 2.92981 1.375 2.42177 1.63235C1.97489 1.85871 1.61156 2.21992 1.38386 2.66419C1.125 3.16926 1.125 3.83043 1.125 5.15278V6.09722M1.125 6.09722H19.175C21.1702 6.09722 22.1678 6.09722 22.9298 6.48324C23.6002 6.82279 24.1452 7.3646 24.4867 8.03101C24.875 8.78861 24.875 9.78037 24.875 11.7639V16.9583C24.875 18.9419 24.875 19.9336 24.4867 20.6912C24.1452 21.3576 23.6002 21.8994 22.9298 22.239C22.1678 22.625 21.1702 22.625 19.175 22.625H6.825C4.82981 22.625 3.83222 22.625 3.07016 22.239C2.39983 21.8994 1.85484 21.3576 1.51329 20.6912C1.125 19.9336 1.125 18.9419 1.125 16.9583V6.09722Z"
        stroke={`${props.tint ?? 'current'}`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgNewFolder(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke={props.tint} strokeWidth={1.5} fill="none" fillRule="evenodd">
        <path d="M21.167 15.117a1.246 1.246 0 011.25 1.25h0v7.666a1.246 1.246 0 01-1.25 1.25h0H6.833a1.246 1.246 0 01-1.25-1.25h0v-8.916zM10.058 11.367a1.248 1.248 0 011.186.854h0l.882 2.646H5.583v-2.25a1.246 1.246 0 011.25-1.25h0z" />
        <g strokeLinecap="round">
          <path d="M21 4.61v6.667M24.334 7.943h-6.667" />
        </g>
      </g>
    </svg>
  );
}
function SvgFolderSolid(props: SvgProps) {
  return (
    <svg
      width="29"
      height="25"
      viewBox="0 0 29 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.6723 2.87915L15.9907 5.51593H21.2341C22.3289 5.51593 23.1872 5.51593 23.877 5.57229C24.5794 5.62968 25.1597 5.74848 25.685 6.0161C26.5485 6.45607 27.2505 7.15809 27.6905 8.02157C27.9581 8.54681 28.0769 9.12711 28.1343 9.82954C28.1906 10.5194 28.1906 11.3776 28.1906 12.4724V12.4992C28.1906 12.8298 27.9226 13.0978 27.5921 13.0978C27.2615 13.0978 26.9935 12.8298 26.9935 12.4992C26.9935 11.3719 26.993 10.5624 26.9411 9.92702C26.8898 9.29863 26.7911 8.89341 26.6238 8.56505C26.2986 7.92683 25.7797 7.40794 25.1415 7.08275C24.8131 6.91545 24.4079 6.81678 23.7795 6.76544C23.1441 6.71353 22.3347 6.71306 21.2074 6.71306H15.6337C15.6254 6.71324 15.617 6.71324 15.6087 6.71306H0.98919C0.658612 6.71306 0.390625 6.44508 0.390625 6.1145V5.02448V5.02447C0.39062 4.30149 0.390615 3.72243 0.428857 3.25437C0.468126 2.77375 0.550682 2.3577 0.745819 1.97472C1.05826 1.36153 1.5568 0.86299 2.16999 0.550553C2.55297 0.355416 2.96901 0.27286 3.44964 0.233592C3.9177 0.19535 4.49676 0.195354 5.21974 0.195359L10.3298 0.195359L10.4358 0.195335C11.2883 0.195045 11.8611 0.194849 12.379 0.373471C12.8356 0.530979 13.2515 0.788031 13.5966 1.12603C13.988 1.50934 14.244 2.02177 14.625 2.78442L14.6723 2.87915Z"
        fill={props.tint}
      />
      <path
        d="M23.877 5.05635C24.5794 5.11375 25.1597 5.23255 25.685 5.50017C26.5485 5.94013 27.2505 6.64216 27.6905 7.50564C27.9581 8.03088 28.0769 8.61118 28.1343 9.3136C28.1906 10.0034 28.1906 10.8617 28.1906 11.9565V17.8627C28.1906 18.9574 28.1906 19.8157 28.1343 20.5055C28.0769 21.208 27.9581 21.7883 27.6905 22.3135C27.2505 23.177 26.5485 23.879 25.685 24.319C25.1597 24.5866 24.5794 24.7054 23.877 24.7628C23.1872 24.8191 22.3289 24.8191 21.2342 24.8191H7.34708C6.25234 24.8191 5.39405 24.8191 4.70423 24.7628C4.0018 24.7054 3.4215 24.5866 2.89626 24.319C2.03278 23.879 1.33076 23.177 0.890796 22.3135C0.62317 21.7883 0.50437 21.208 0.446979 20.5055C0.390618 19.8157 0.390621 18.9574 0.390625 17.8627V5.59856C0.390625 5.26799 0.658612 5 0.98919 5H21.2341C22.3289 5 23.1872 4.99999 23.877 5.05635Z"
        fill="#D2D6DB"
      />
    </svg>
  );
}
function SvgFolderSmall(props: SvgProps) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8307 4.83333L9.90111 2.9741C9.63357 2.439 9.49978 2.17144 9.3002 1.97597C9.12371 1.80311 8.911 1.67164 8.67746 1.59109C8.41337 1.5 8.11424 1.5 7.51597 1.5H4.33073C3.39731 1.5 2.9306 1.5 2.57408 1.68166C2.26047 1.84144 2.00551 2.09641 1.84572 2.41002C1.66406 2.76654 1.66406 3.23325 1.66406 4.16667V4.83333M1.66406 4.83333H14.3307C15.7309 4.83333 16.4309 4.83333 16.9657 5.10582C17.4361 5.3455 17.8186 5.72795 18.0582 6.19836C18.3307 6.73314 18.3307 7.4332 18.3307 8.83333V12.5C18.3307 13.9001 18.3307 14.6002 18.0582 15.135C17.8186 15.6054 17.4361 15.9878 16.9657 16.2275C16.4309 16.5 15.7309 16.5 14.3307 16.5H5.66406C4.26393 16.5 3.56387 16.5 3.02909 16.2275C2.55868 15.9878 2.17623 15.6054 1.93655 15.135C1.66406 14.6002 1.66406 13.9001 1.66406 12.5V4.83333Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgDumbbellFlat(props: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={props.tint}
      {...props}
    >
      <rect x="4" y="6" width="4" height="12" rx="1" stroke={props.tint} strokeWidth="1.5" />
      <rect
        x="20"
        y="18"
        width="4"
        height="12"
        rx="1"
        transform="rotate(-180 20 18)"
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <path
        d="M4 9H2C1.44772 9 1 9.44772 1 10V14C1 14.5523 1.44772 15 2 15H4"
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <path
        d="M20 15L22 15C22.5523 15 23 14.5523 23 14L23 10C23 9.44772 22.5523 9 22 9L20 9"
        stroke={props.tint}
        strokeWidth="1.5"
      />
      <line x1="8" y1="11.75" x2="16" y2="11.75" stroke={props.tint} strokeWidth="1.5" />
    </svg>
  );
}

function SvgDumbbellBig(props: SvgProps) {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd" stroke={props.tint}>
        <rect strokeWidth={1.563} x={22.044} y={7.781} width={3.572} height={13.841} rx={0.893} />
        <rect strokeWidth={1.563} x={4.184} y={7.781} width={3.572} height={13.841} rx={0.893} />
        <rect strokeWidth={1.563} x={25.616} y={10.684} width={2.902} height={7.814} rx={0.893} />
        <rect
          strokeWidth={1.563}
          transform="matrix(-1 0 0 1 5.465 0)"
          x={1.281}
          y={10.684}
          width={2.902}
          height={7.814}
          rx={0.893}
        />
        <path strokeWidth={1.563} d="M25.761 10.081v8.803" />
        <path strokeWidth={1.7} d="M7.733 14.702h14.112" />
      </g>
    </svg>
  );
}

function SvgCamera(props: SvgProps) {
  return (
    <svg
      width="26px"
      height="23px"
      viewBox="0 0 26 23"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.568 5.322a2.95 2.95 0 00-2.165-.897h-2.679l-.61-1.626c-.151-.39-.428-.728-.831-1.011-.403-.283-.816-.425-1.238-.425H9.92c-.423 0-.836.142-1.238.425-.403.283-.68.62-.832 1.01l-.61 1.627H4.562c-.845 0-1.567.3-2.165.897A2.95 2.95 0 001.5 7.487v10.717c0 .846.299 1.567.897 2.165a2.95 2.95 0 002.165.898h16.841c.845 0 1.567-.3 2.165-.898a2.95 2.95 0 00.897-2.165V7.487a2.95 2.95 0 00-.897-2.165zm-7.63 10.479c-.853.853-1.88 1.28-3.08 1.28-1.2 0-2.226-.427-3.079-1.28-.853-.853-1.279-1.88-1.279-3.08 0-1.2.427-2.225 1.28-3.078.852-.853 1.879-1.28 3.079-1.28 1.2 0 2.226.427 3.079 1.28.853.852 1.28 1.879 1.28 3.079 0 1.2-.427 2.226-1.28 3.079z"
        fillRule="nonzero"
        stroke={props.tint}
        strokeWidth={1.5}
        fill="none"
      />
    </svg>
  );
}

function SvgBicep(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.845 7.535l-1.835.917a.335.335 0 00-.158.432l.397.933a.652.652 0 00-.374.63c.015.312.231.561.537.62.187.037.393.061.591.084.374.044.798.093 1.01.226.235.148.518.21.8.223.555.538.753 1.474.677 1.975-.035.23-.099.54-.166.868-.051.247-.106.512-.156.783a3.477 3.477 0 00-3.567.045l-.356.219c-.03-.02-.06-.038-.091-.057a4.714 4.714 0 00-3.368-.643 1.505 1.505 0 00-.173.044 2.999 2.999 0 00-2.083 2.721l-.027.578a3.003 3.003 0 001.81 2.898 4.106 4.106 0 003.64-.21c.514.288 1.35.601 2.61.667 1.715.089 3.764-.306 6.088-1.174a.327.327 0 00.025-.01c.344-.163.584-.461.714-.889.078-.258.11-.547.11-.848 0-.656-.153-1.365-.31-1.92a12.497 12.497 0 00-1.234-2.888 155.988 155.988 0 01-2.587-4.56.335.335 0 00-.096-.11l-2.082-1.525a.333.333 0 00-.346-.029zm1.974 2.05c.229.419 1.5 2.738 2.564 4.518.936 1.564 1.709 3.993 1.368 5.117-.072.237-.186.391-.348.472-4.412 1.644-6.78 1.165-7.851.681.084-.067.17-.132.258-.193a.336.336 0 00.082-.467.333.333 0 00-.465-.082 5.97 5.97 0 00-.442.343 2.432 2.432 0 01-.269.208 3.437 3.437 0 01-3.143.233 2.33 2.33 0 01-1.403-2.25l.027-.579a2.327 2.327 0 011.71-2.138 4.05 4.05 0 012.893.553c.357.223.695.426 1.005.603a.333.333 0 00.499-.291c0-.117-.061-.23-.17-.292-.08-.045-.161-.093-.245-.142l.062-.037a2.809 2.809 0 013.097.103 6.705 6.705 0 00-.076 1.075.334.334 0 10.667-.018c-.019-.692.18-1.652.339-2.423.072-.352.135-.655.173-.904a2.14 2.14 0 00.021-.317c0-.53-.159-1.241-.55-1.824a4.01 4.01 0 00.481-.123.335.335 0 00-.21-.636c-.003.001-.279.092-.618.135-.4.052-.722.016-.908-.101-.34-.213-.821-.269-1.287-.323a7.888 7.888 0 01-.52-.072c.901-.257 2.02-.02 2.03-.018a.335.335 0 00.142-.655 4.857 4.857 0 00-.363-.06l-.883-.057a4.89 4.89 0 00-.576.039l-.32-.752 1.372-.685 1.857 1.36z"
        stroke={props.tint}
        strokeWidth={0.5}
        fill={props.tint}
        fillRule="nonzero"
      />
    </svg>
  );
}

function SvgCheck(props: SvgProps) {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 1.25L5.125 8.125L2 5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgCheckCircle(props: SvgProps) {
  return (
    <svg
      width={props.width ?? 16}
      height={props.height ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00004 7.99998L7.00004 9.99998L11 5.99998M14.6667 7.99998C14.6667 11.6819 11.6819 14.6666 8.00004 14.6666C4.31814 14.6666 1.33337 11.6819 1.33337 7.99998C1.33337 4.31808 4.31814 1.33331 8.00004 1.33331C11.6819 1.33331 14.6667 4.31808 14.6667 7.99998Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgMicroDumbbell(props: SvgProps) {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(7 10)" fill={props.tint} fillRule="evenodd">
        <rect y={3.84} width={16.8} height={1.92} rx={0.9} />
        <rect
          stroke={props.tint}
          strokeWidth={0.9}
          x={2.25}
          y={0.45}
          width={2.1}
          height={8.7}
          rx={0.6}
        />
        <rect
          stroke={props.tint}
          strokeWidth={0.9}
          x={12.45}
          y={0.45}
          width={2.1}
          height={8.7}
          rx={0.6}
        />
        <path
          d="M14.25 2.37h1.55l.505 4.35-2.055.411V2.37zM2.55 2.469V7.23H1L.496 2.88l2.055-.411z"
          stroke={props.tint}
          strokeWidth={0.9}
        />
      </g>
    </svg>
  );
}

function SvgMeasure(props: SvgProps) {
  return (
    <svg
      width="29px"
      height="28px"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.929 10.5478C12.929 11.4338 11.4925 12.152 9.72066 12.152C7.94887 12.152 6.51233 11.4338 6.51233 10.5478C6.51233 9.66185 7.94887 8.94366 9.72066 8.94366C11.4925 8.94366 12.929 9.66185 12.929 10.5478Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M19.3468 10.0139C19.3468 12.9673 15.277 15.3611 10.2565 15.3611C5.23601 15.3611 1.16663 12.9673 1.16663 10.0139C1.16663 7.06049 5.23642 4.66666 10.2569 4.66666C15.2774 4.66666 19.3472 7.06089 19.3472 10.0139H19.3468Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M10.0983 15.3625H26.8323V21.7784H10.0983C5.16543 21.7788 1.16663 19.3843 1.16663 16.4305V10.0146"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M26.8348 21.777H21.4875V15.3604H26.8348V21.777Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11.8625 18.5687V21.777"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M5.44592 18.5687V20.7076"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18.2793 18.5687V21.777"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8.6543 19.6396V21.5839"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M15.0709 19.6396V21.7785"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M19.3457 10.0146V15.3619"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgSearch(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 18L14.2779 14.2778M16.2222 9.61111C16.2222 13.2623 13.2623 16.2222 9.61111 16.2222C5.95989 16.2222 3 13.2623 3 9.61111C3 5.95989 5.95989 3 9.61111 3C13.2623 3 16.2222 5.95989 16.2222 9.61111Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgSearchCross(props: SvgProps) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 2L5 5M5 5L8 8M5 5L2 8M5 5L8 2"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgBody(props: SvgProps) {
  return (
    <svg
      width="21"
      height="28"
      viewBox="0 0 21 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2919 7.58341C13.0638 7.58341 14.5002 6.14697 14.5002 4.37504C14.5002 2.60311 13.0638 1.16667 11.2919 1.16667C9.51993 1.16667 8.0835 2.60311 8.0835 4.37504C8.0835 6.14697 9.51993 7.58341 11.2919 7.58341Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7094 14.9838L17.6303 18.026C17.8896 18.2417 18.2201 18.3528 18.557 18.3375C18.8939 18.3221 19.2129 18.1813 19.4514 17.9429C19.6899 17.7044 19.8306 17.3854 19.846 17.0485C19.8614 16.7115 19.7503 16.381 19.5345 16.1218L15.0727 10.3868C14.8648 10.1768 14.6174 10.0099 14.3448 9.89582C14.0721 9.78173 13.7796 9.72268 13.4841 9.72205H8.07585C7.476 9.72526 6.90142 9.96399 6.47592 10.3868L2.01415 16.1218C1.78183 16.3797 1.65759 16.717 1.66714 17.064C1.67669 17.411 1.81931 17.741 2.06546 17.9857C2.31161 18.2304 2.64244 18.371 2.98945 18.3785C3.33645 18.3861 3.67306 18.2598 3.92956 18.026L7.85051 14.9838L4.71825 24.8539C4.64279 25.0152 4.59984 25.1898 4.59184 25.3676C4.58384 25.5455 4.61096 25.7232 4.67164 25.8906C4.73232 26.058 4.82538 26.2118 4.94551 26.3433C5.06563 26.4747 5.21047 26.5812 5.37174 26.6567C5.53302 26.7321 5.70759 26.7751 5.88546 26.7831C6.06334 26.7911 6.24106 26.764 6.40846 26.7033C6.57585 26.6426 6.72966 26.5495 6.8611 26.4294C6.99253 26.3093 7.09902 26.1644 7.17448 26.0032L10.78 20.3245L14.3854 26.0032C14.4559 26.1715 14.5596 26.3238 14.6905 26.451C14.8213 26.5781 14.9766 26.6775 15.1469 26.743C15.3171 26.8086 15.4989 26.839 15.6813 26.8325C15.8636 26.8259 16.0427 26.7825 16.2078 26.7049C16.373 26.6273 16.5207 26.5171 16.6421 26.3808C16.7635 26.2446 16.856 26.0852 16.9142 25.9123C16.9724 25.7393 16.9949 25.5564 16.9805 25.3745C16.9661 25.1926 16.915 25.0155 16.8304 24.8539L13.7094 14.9838Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgPr(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ellipse cx="7.99941" cy="5.5842" rx="5.58776" ry="5.58518" fill="#F7D000" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7194 9.79869C12.5796 11.2534 10.8729 12.2431 8.93157 12.4355L10.5175 15.9997L12.212 13.1095L15.4143 13.6078L13.7194 9.79869ZM7.70376 12.4496C5.60242 12.2907 3.76166 11.1991 2.59478 9.58789L0.585724 13.6424L4.11011 13.1159L5.94768 15.9936L7.70376 12.4496Z"
        fill="#F7AB00"
      />
    </svg>
  );
}

function SvgArrowDown(props: SvgProps) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.30217 1.3033L11.9088 11.9099M11.9088 11.9099V1.3033M11.9088 11.9099H1.30217"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}

function SvgArrowUp(props: SvgProps) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.30217 11.9099L11.9088 1.3033M11.9088 1.3033H1.30217M11.9088 1.3033V11.9099"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}

function SvgArrowRight(props: SvgProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.10434 8.60742L16.1043 8.60742M16.1043 8.60742L8.60434 1.10742M16.1043 8.60742L8.60434 16.1074"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}

function SvgEmail(props: SvgProps) {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.66669 3.83333L8.47079 8.5962C9.02176 8.98188 9.29725 9.17472 9.59691 9.24942C9.8616 9.3154 10.1384 9.3154 10.4031 9.24942C10.7028 9.17472 10.9783 8.98188 11.5293 8.5962L18.3334 3.83333M5.66669 14.6667H14.3334C15.7335 14.6667 16.4336 14.6667 16.9683 14.3942C17.4387 14.1545 17.8212 13.772 18.0609 13.3016C18.3334 12.7669 18.3334 12.0668 18.3334 10.6667V5.33333C18.3334 3.9332 18.3334 3.23313 18.0609 2.69835C17.8212 2.22795 17.4387 1.8455 16.9683 1.60581C16.4336 1.33333 15.7335 1.33333 14.3334 1.33333H5.66669C4.26656 1.33333 3.56649 1.33333 3.03171 1.60581C2.56131 1.8455 2.17885 2.22795 1.93917 2.69835C1.66669 3.23313 1.66669 3.9332 1.66669 5.33333V10.6667C1.66669 12.0668 1.66669 12.7669 1.93917 13.3016C2.17885 13.772 2.56131 14.1545 3.03171 14.3942C3.56649 14.6667 4.26656 14.6667 5.66669 14.6667Z"
        stroke={props.tint}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgQuestionCircle(props: SvgProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
        stroke={props.tint}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99805 10.1094H7.00337"
        stroke={props.tint}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99888 8.57706V7.45721C8.01457 7.45721 8.83181 6.60594 8.77891 5.57917C8.73093 4.65287 7.96291 3.90986 7.03578 3.891C6.11932 3.87254 5.35662 4.54626 5.23402 5.425C5.22254 5.50619 5.2168 5.58943 5.2168 5.6739"
        stroke={props.tint}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgPaperAirplane(props: SvgProps) {
  return (
    <svg
      width={props.width ?? 22}
      height={props.height ?? 22}
      viewBox={`0 0 ${props.width ?? 22} ${props.height ?? 22}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.49952 12.5001L19.9995 2.00005M9.6271 12.8281L12.2552 19.5861C12.4867 20.1815 12.6025 20.4791 12.7693 20.566C12.9139 20.6414 13.0862 20.6415 13.2308 20.5663C13.3977 20.4796 13.5139 20.1821 13.7461 19.587L20.3364 2.69925C20.5461 2.16207 20.6509 1.89348 20.5935 1.72185C20.5437 1.5728 20.4268 1.45583 20.2777 1.40604C20.1061 1.34871 19.8375 1.45352 19.3003 1.66315L2.41258 8.25349C1.8175 8.48572 1.51997 8.60183 1.43326 8.76873C1.35809 8.91342 1.35819 9.08567 1.43353 9.23027C1.52043 9.39707 1.81811 9.51283 2.41345 9.74436L9.17146 12.3725C9.29231 12.4195 9.35273 12.443 9.40361 12.4793C9.44871 12.5114 9.48815 12.5509 9.52031 12.596C9.55661 12.6468 9.58011 12.7073 9.6271 12.8281Z"
        stroke={props.tint ?? colors.white}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgLike(props: SvgProps) {
  return (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>like</title>
      <g id="Styles-&amp;-Assets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Artboard"
          transform="translate(-2178.000000, -262.000000)"
          fill={props.tint}
          fillRule="nonzero"
          stroke={props.tint}
          strokeWidth="0.5"
        >
          <path
            d="M2198.39977,276.913125 C2198.82141,276.364192 2199.02362,275.775735 2198.99781,275.169713 C2198.97199,274.502209 2198.67943,273.979625 2198.43849,273.659048 C2198.71815,272.94763 2198.82571,271.827805 2197.89208,270.958295 C2197.20799,270.321532 2196.04632,270.036086 2194.43721,270.115133 C2193.30566,270.16783 2192.35912,270.383012 2192.3204,270.391795 L2192.3161,270.391795 C2192.10097,270.431319 2191.87294,270.479625 2191.64061,270.532322 C2191.6234,270.251268 2191.67073,269.553025 2192.17842,267.980879 C2192.78076,266.110114 2192.74634,264.678495 2192.06655,263.721155 C2191.35235,262.715509 2190.2122,262.636463 2189.8766,262.636463 C2189.55392,262.636463 2189.25705,262.772598 2189.04623,263.022912 C2188.56866,263.589411 2188.62459,264.634581 2188.68482,265.117642 C2188.1169,266.672222 2186.52499,270.484016 2185.17832,271.54236 C2185.15251,271.559926 2185.131,271.581883 2185.10948,271.603841 C2184.71366,272.029813 2184.44691,272.490917 2184.2662,272.894932 C2184.01236,272.754405 2183.72409,272.675359 2183.41432,272.675359 L2180.78982,272.675359 C2179.80026,272.675359 2179,273.496563 2179,274.502209 L2179,281.638345 C2179,282.648383 2179.80456,283.465196 2180.78982,283.465196 L2183.41432,283.465196 C2183.79724,283.465196 2184.15434,283.342235 2184.44691,283.131444 L2185.45798,283.254405 C2185.61287,283.276362 2188.36644,283.632071 2191.19315,283.574982 C2191.70515,283.614506 2192.18702,283.636463 2192.63448,283.636463 C2193.40462,283.636463 2194.0758,283.574982 2194.63512,283.452021 C2195.95167,283.166576 2196.85088,282.595685 2197.30694,281.756915 C2197.65544,281.11576 2197.65544,280.478997 2197.59951,280.074982 C2198.4557,279.284518 2198.60628,278.410616 2198.57617,277.79581 C2198.55896,277.440102 2198.48151,277.13709 2198.39977,276.913125 Z M2180.78982,282.279499 C2180.44132,282.279499 2180.16166,281.989662 2180.16166,281.638345 L2180.16166,274.497818 C2180.16166,274.142109 2180.44562,273.856664 2180.78982,273.856664 L2183.41432,273.856664 C2183.76282,273.856664 2184.04248,274.1465 2184.04248,274.497818 L2184.04248,281.633953 C2184.04248,281.989662 2183.75851,282.275108 2183.41432,282.275108 L2180.78982,282.275108 L2180.78982,282.279499 Z M2197.29834,276.399324 C2197.11763,276.592548 2197.08321,276.886777 2197.22089,277.115133 C2197.22089,277.119524 2197.39729,277.426927 2197.41881,277.848508 C2197.44892,278.42379 2197.17787,278.933201 2196.60994,279.367956 C2196.40773,279.526049 2196.32598,279.79832 2196.41203,280.044242 C2196.41203,280.048633 2196.59704,280.628307 2196.29587,281.177241 C2196.0076,281.704217 2195.36654,282.081883 2194.39418,282.292674 C2193.61544,282.463941 2192.55703,282.494681 2191.25769,282.389286 C2191.24048,282.389286 2191.21897,282.389286 2191.19746,282.389286 C2188.43098,282.450766 2185.63438,282.081883 2185.60427,282.077492 L2185.59996,282.077492 L2185.16542,282.024794 C2185.19123,281.901833 2185.20414,281.770089 2185.20414,281.638345 L2185.20414,274.497818 C2185.20414,274.308985 2185.17402,274.124543 2185.12239,273.953276 C2185.19984,273.659048 2185.41496,273.004719 2185.92265,272.447002 C2187.85445,270.88364 2189.74323,265.609487 2189.82497,265.38113 C2189.85939,265.28891 2189.868,265.187906 2189.85079,265.086902 C2189.77765,264.595058 2189.80346,263.993426 2189.90672,263.813376 C2190.13475,263.817768 2190.75,263.88364 2191.12001,264.406224 C2191.55886,265.025421 2191.54165,266.132071 2191.06838,267.598822 C2190.34557,269.834079 2190.28534,271.010992 2190.85756,271.529186 C2191.14153,271.788282 2191.52014,271.801457 2191.7955,271.700453 C2192.05795,271.638972 2192.30749,271.586275 2192.54413,271.546751 C2192.56134,271.54236 2192.58285,271.537969 2192.60006,271.533577 C2193.92091,271.239349 2196.28726,271.059298 2197.10903,271.823414 C2197.80603,272.473351 2197.31124,273.334079 2197.25531,273.4263 C2197.09612,273.672222 2197.14345,273.992799 2197.35857,274.190415 C2197.36287,274.194807 2197.81463,274.629562 2197.83614,275.213627 C2197.85335,275.604468 2197.67265,276.004091 2197.29834,276.399324 Z"
            id="like"
          ></path>
        </g>
      </g>
    </svg>
  );
}

function SvgLikeFilled(props: SvgProps) {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Styles-&amp;-Assets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard" transform="translate(-2207.000000, -206.000000)" fill={props.tint}>
          <g
            id="Group-2"
            transform="translate(2220.000000, 219.136463) rotate(-12.000000) translate(-2220.000000, -219.136463) translate(2209.500000, 208.636463)"
          >
            <path
              d="M19.8997655,14.2766625 C20.321406,13.727729 20.5236213,13.1392723 20.4978066,12.5332497 C20.4719919,11.8657465 20.179425,11.3431619 19.9384876,11.0225847 C20.2181471,10.3111669 20.3257085,9.19134253 19.3920759,8.32183187 C18.7079857,7.68506901 17.5463231,7.39962359 15.9372053,7.47867001 C14.8056599,7.53136763 13.85912,7.74654956 13.8203979,7.7553325 C13.6009727,7.79485571 13.3729426,7.84316186 13.1406101,7.89585947 C13.1234003,7.61480552 13.1707273,6.91656211 13.6784169,5.34441656 C14.2807605,3.47365119 14.2463408,2.04203262 13.5665531,1.0846926 C12.8523457,0.0790464241 11.7121954,0 11.3766039,0 C11.0539199,0 10.7570506,0.136135508 10.5462303,0.386449184 C10.0686579,0.952948557 10.1245898,1.99811794 10.1848242,2.48117942 C9.61690022,4.0357591 8.02499221,7.84755332 6.67832408,8.90589711 C6.65250935,8.92346299 6.63099708,8.94542033 6.60948481,8.96737767 C6.43001888,9.16051196 6.24259292,9.42135221 6.04720694,9.74989841 C5.86328368,10.059177 5.76620381,10.4123467 5.76620381,10.7721814 L5.76620381,19.5544735 C5.76620381,20.0263051 6.09600537,20.4339388 6.55744071,20.5324398 L6.95798359,20.6179423 L6.95798359,20.6179423 C7.11287194,20.6398996 9.86644256,20.9956085 12.6931549,20.9385194 C13.2051469,20.9780427 13.6870218,21 14.134477,21 C14.9046163,21 15.5757991,20.9385194 16.1351182,20.8155583 C17.4516691,20.5301129 18.350882,19.9592221 18.8069422,19.1204517 C19.1554409,18.4792974 19.1554409,17.8425345 19.099509,17.4385194 C19.9556974,16.6480552 20.1062833,15.7741531 20.0761661,15.1593476 C20.0589563,14.8036386 19.9815121,14.5006274 19.8997655,14.2766625 Z"
              id="like-copy"
              fillRule="nonzero"
            ></path>
            <rect id="Rectangle" x="0" y="10.3635371" width="5" height="10" rx="1"></rect>
          </g>
        </g>
      </g>
    </svg>
  );
}

function SvgShare(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 10V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V10M14 5L10 1M10 1L6 5M10 1V13"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgMenu(props: SvgProps) {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 7.00002L6.5 7.00002M16.5 2.00002L6.5 2.00002M16.5 12L6.5 12M3.16667 7.00002C3.16667 7.46026 2.79357 7.83335 2.33333 7.83335C1.8731 7.83335 1.5 7.46026 1.5 7.00002C1.5 6.53978 1.8731 6.16669 2.33333 6.16669C2.79357 6.16669 3.16667 6.53978 3.16667 7.00002ZM3.16667 2.00002C3.16667 2.46026 2.79357 2.83335 2.33333 2.83335C1.8731 2.83335 1.5 2.46026 1.5 2.00002C1.5 1.53978 1.8731 1.16669 2.33333 1.16669C2.79357 1.16669 3.16667 1.53978 3.16667 2.00002ZM3.16667 12C3.16667 12.4603 2.79357 12.8334 2.33333 12.8334C1.8731 12.8334 1.5 12.4603 1.5 12C1.5 11.5398 1.8731 11.1667 2.33333 11.1667C2.79357 11.1667 3.16667 11.5398 3.16667 12Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgVideo(props: SvgProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.91667 6.47111C6.91667 6.07337 6.91667 5.8745 6.99978 5.76348C7.07222 5.66673 7.18309 5.6062 7.30365 5.59759C7.44199 5.58771 7.60927 5.69524 7.94384 5.91032L11.8777 8.43921C12.168 8.62585 12.3131 8.71917 12.3633 8.83783C12.4071 8.9415 12.4071 9.0585 12.3633 9.16217C12.3131 9.28083 12.168 9.37415 11.8777 9.56079L7.94384 12.0897C7.60927 12.3048 7.44199 12.4123 7.30365 12.4024C7.18309 12.3938 7.07222 12.3333 6.99978 12.2365C6.91667 12.1255 6.91667 11.9266 6.91667 11.5289V6.47111Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 5.5C1.5 4.09987 1.5 3.3998 1.77248 2.86502C2.01217 2.39462 2.39462 2.01217 2.86502 1.77248C3.3998 1.5 4.09987 1.5 5.5 1.5H12.5C13.9001 1.5 14.6002 1.5 15.135 1.77248C15.6054 2.01217 15.9878 2.39462 16.2275 2.86502C16.5 3.3998 16.5 4.09987 16.5 5.5V12.5C16.5 13.9001 16.5 14.6002 16.2275 15.135C15.9878 15.6054 15.6054 15.9878 15.135 16.2275C14.6002 16.5 13.9001 16.5 12.5 16.5H5.5C4.09987 16.5 3.3998 16.5 2.86502 16.2275C2.39462 15.9878 2.01217 15.6054 1.77248 15.135C1.5 14.6002 1.5 13.9001 1.5 12.5V5.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgLink(props: SvgProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.58961 14.3033L8.4111 15.4818C6.78392 17.109 4.14573 17.109 2.51855 15.4818C0.89136 13.8546 0.891361 11.2164 2.51855 9.58923L3.69706 8.41072M14.3037 9.58923L15.4822 8.41072C17.1094 6.78354 17.1094 4.14535 15.4822 2.51816C13.855 0.890979 11.2168 0.890979 9.58961 2.51816L8.4111 3.69668M6.08369 11.9166L11.917 6.08329"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgChevronDown(props: SvgProps) {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 2L6 6L10 2"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgWifiOff(props: SvgProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.208 6.66668C11.1202 6.95089 11.975 7.41274 12.7201 8.03334M15.0534 5.66665C13.1051 3.94929 10.5972 3.00175 8.00003 3.00175C7.59669 3.00175 7.1955 3.0246 6.79823 3.06964M5.6866 10.4067C6.36341 9.92585 7.17305 9.66752 8.00327 9.66752C8.83349 9.66752 9.64314 9.92585 10.3199 10.4067M8.00008 13H8.00675M0.795654 5.80051C1.68472 4.9858 2.71234 4.31983 3.83909 3.84204M3.1547 8.16198C4.08631 7.34132 5.2279 6.75344 6.48851 6.48929M10.4656 10.5167C9.78623 9.98418 8.9302 9.66667 8.00001 9.66667C7.05574 9.66667 6.1879 9.99386 5.50366 10.5411M2.00008 2L14.0001 14"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgProgram(props: SvgProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 11.25L25 8.5C25 6.3998 25 5.3497 24.5913 4.54754C24.2317 3.84193 23.6581 3.26825 22.9525 2.90873C22.1503 2.5 21.1002 2.5 19 2.5H11C8.8998 2.5 7.8497 2.5 7.04754 2.90873C6.34193 3.26825 5.76825 3.84193 5.40873 4.54754C5 5.3497 5 6.3998 5 8.5V21.5C5 23.6002 5 24.6503 5.40873 25.4525C5.76825 26.1581 6.34193 26.7317 7.04754 27.0913C7.8497 27.5 8.8998 27.5 11 27.5H12.5M17.5 13.75H10M12.5 18.75H10M20 8.75H10"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1513 16.3006L27.5298 19.6791L28.3183 18.8906L24.9398 15.5121L24.1513 16.3006ZM28.5904 20.7398L28.8003 20.9496C29.2771 21.4264 29.324 22.2264 28.8149 22.7355L27.7491 23.8014C27.24 24.3105 26.44 24.2636 25.9632 23.7868L23.6395 21.4631C23.6029 21.5546 23.5475 21.6404 23.4734 21.7145L21.6969 23.491C21.6296 23.5584 21.5526 23.6102 21.4704 23.6466L23.7861 25.9624C24.2629 26.4392 24.3098 27.2392 23.8007 27.7483L22.7349 28.8141C22.2258 29.3232 21.4258 29.2763 20.949 28.7995L20.7401 28.5906L19.865 29.4657C19.6347 29.696 19.3233 29.8567 18.9804 29.8879C18.6323 29.9197 18.2636 29.8132 17.9903 29.5399L14.291 25.8406C14.0177 25.5673 13.9112 25.1986 13.9429 24.8505C13.9742 24.5076 14.1349 24.1961 14.3652 23.9659L15.2403 23.0908L15.0301 22.8806C14.5533 22.4038 14.5064 21.6038 15.0155 21.0947L16.0813 20.0289C16.5904 19.5198 17.3904 19.5667 17.8672 20.0435L20.4806 22.6569C20.517 22.5747 20.5689 22.4977 20.6363 22.4303L22.4127 20.6539C22.4869 20.5797 22.5726 20.5244 22.6642 20.4878L20.0443 17.8679C19.5675 17.3911 19.5206 16.5911 20.0297 16.082L21.0955 15.0161C21.6046 14.507 22.4046 14.5539 22.8814 15.0307L23.0906 15.2399L23.9654 14.3652C24.1957 14.1349 24.5071 13.9742 24.85 13.9429C25.1981 13.9112 25.5668 14.0177 25.8401 14.291L29.5394 17.9903C29.8127 18.2636 29.9192 18.6323 29.8875 18.9804C29.8562 19.3233 29.6955 19.6347 29.4652 19.865L28.5904 20.7398ZM21.2653 16.9676L26.8634 22.5657L27.5792 21.8499L21.9812 16.2518L21.2653 16.9676ZM22.565 26.8626L16.967 21.2645L16.2512 21.9804L21.8492 27.5784L22.565 26.8626ZM16.3009 24.1514L19.6794 27.5299L18.8906 28.3188L15.5121 24.9403L16.3009 24.1514Z"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgReorder(props: SvgProps) {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="5" cy="4" r="1.75" fill={props.tint} />
      <circle cx="5" cy="10" r="1.75" fill={props.tint} />
      <circle cx="5" cy="16" r="1.75" fill={props.tint} />
      <circle cx="11" cy="4" r="1.75" fill={props.tint} />
      <circle cx="11" cy="10" r="1.75" fill={props.tint} />
      <circle cx="11" cy="16" r="1.75" fill={props.tint} />
    </svg>
  );
}

function SvgAssign(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1667 13.6595C12.9466 12.9229 11.5226 12.5 10.0015 12.5C7.35977 12.5 5.0105 13.7755 3.51483 15.755C3.19292 16.181 3.03197 16.394 3.03723 16.6819C3.0413 16.9043 3.18097 17.1849 3.35598 17.3222C3.58249 17.5 3.89639 17.5 4.5242 17.5H10.0015M13.7515 6.25C13.7515 8.32107 12.0726 10 10.0015 10C7.93044 10 6.2515 8.32107 6.2515 6.25C6.2515 4.17893 7.93044 2.5 10.0015 2.5C12.0726 2.5 13.7515 4.17893 13.7515 6.25Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M13.3335 16.6667L15.0002 18.3333L18.3335 15"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgSend(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.0624 11.3182L5.06238 3.06819C4.94811 3.01582 4.82252 2.99301 4.69714 3.00186C4.57177 3.0107 4.45062 3.05092 4.34484 3.11881C4.23907 3.18671 4.15205 3.2801 4.0918 3.3904C4.03154 3.50071 3.99997 3.62439 4 3.75008V10.5001L13 12.0001L4 13.5001V20.2501C3.99997 20.3758 4.03154 20.4995 4.0918 20.6098C4.15205 20.7201 4.23907 20.8135 4.34484 20.8813C4.45062 20.9492 4.57177 20.9895 4.69714 20.9983C4.82252 21.0071 4.94811 20.9843 5.06238 20.932L23.0624 12.682C23.193 12.6221 23.3036 12.5261 23.3812 12.4052C23.4588 12.2843 23.5 12.1437 23.5 12.0001C23.5 11.8564 23.4588 11.7158 23.3812 11.595C23.3036 11.4741 23.193 11.378 23.0624 11.3182Z"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgExpand(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5556 8.44444L17 3M17 3H12.3333M17 3V7.66667M8.44444 11.5556L3 17M3 17H7.66667M3 17L3 12.3333"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgNewChat(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2437_41656)">
        <path
          d="M9.16663 3.33333H5.66663C4.26649 3.33333 3.56643 3.33333 3.03165 3.60582C2.56124 3.8455 2.17879 4.22795 1.93911 4.69836C1.66663 5.23314 1.66663 5.9332 1.66663 7.33333V14.3333C1.66663 15.7335 1.66663 16.4335 1.93911 16.9683C2.17879 17.4387 2.56124 17.8212 3.03165 18.0609C3.56643 18.3333 4.26649 18.3333 5.66663 18.3333H12.6666C14.0668 18.3333 14.7668 18.3333 15.3016 18.0609C15.772 17.8212 16.1545 17.4387 16.3941 16.9683C16.6666 16.4335 16.6666 15.7335 16.6666 14.3333V10.8333M6.6666 13.3333H8.06206C8.46971 13.3333 8.67353 13.3333 8.86535 13.2873C9.03541 13.2465 9.19798 13.1791 9.3471 13.0877C9.5153 12.9847 9.65942 12.8405 9.94767 12.5523L17.9166 4.58334C18.607 3.89298 18.607 2.77369 17.9166 2.08333C17.2263 1.39298 16.107 1.39298 15.4166 2.08333L7.44765 10.0523C7.1594 10.3405 7.01527 10.4847 6.9122 10.6529C6.82082 10.802 6.75348 10.9646 6.71265 11.1346C6.6666 11.3264 6.6666 11.5303 6.6666 11.9379V13.3333Z"
          stroke={props.tint}
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2437_41656">
          <rect width="20" height="20" fill={props.tint} />
        </clipPath>
      </defs>
    </svg>
  );
}

function SvgChats(props: SvgProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.89062 16.875L4.25 20.625V5.625C4.25 5.37636 4.34877 5.1379 4.52459 4.96209C4.7004 4.78627 4.93886 4.6875 5.1875 4.6875H20.1875C20.4361 4.6875 20.6746 4.78627 20.8504 4.96209C21.0262 5.1379 21.125 5.37636 21.125 5.625V15.9375C21.125 16.1861 21.0262 16.4246 20.8504 16.6004C20.6746 16.7762 20.4361 16.875 20.1875 16.875H8.89062Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.875 16.875V21.5625C9.875 21.8111 9.97377 22.0496 10.1496 22.2254C10.3254 22.4012 10.5639 22.5 10.8125 22.5H22.1094L26.75 26.25V11.25C26.75 11.0014 26.6512 10.7629 26.4754 10.5871C26.2996 10.4113 26.0611 10.3125 25.8125 10.3125H21.125"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgMessage(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.09375 15.7266L3.52344 17.8828C3.43238 17.9582 3.32183 18.0061 3.20461 18.0212C3.08738 18.0363 2.96829 18.0178 2.86115 17.9679C2.75401 17.918 2.66321 17.8387 2.59929 17.7393C2.53536 17.6399 2.50094 17.5244 2.5 17.4063V5C2.5 4.83424 2.56585 4.67527 2.68306 4.55806C2.80027 4.44085 2.95924 4.375 3.125 4.375H16.875C17.0408 4.375 17.1997 4.44085 17.3169 4.55806C17.4342 4.67527 17.5 4.83424 17.5 5V15C17.5 15.1658 17.4342 15.3247 17.3169 15.4419C17.1997 15.5592 17.0408 15.625 16.875 15.625H6.38281L6.09375 15.7266Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 8.75H12.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11.25H12.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgClients(props: SvgProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.1828 18.9047C23.9228 19.7681 25.4146 21.1537 26.5035 22.8864C26.7192 23.2295 26.827 23.401 26.8643 23.6386C26.94 24.1214 26.6058 24.7149 26.1506 24.906C25.9266 25 25.6746 25 25.1707 25M19.7925 13.8228C21.5634 12.9535 22.7804 11.1484 22.7804 9.0625C22.7804 6.97662 21.5634 5.17152 19.7925 4.30222M17.4023 9.0625C17.4023 11.9965 14.9944 14.375 12.0241 14.375C9.05389 14.375 6.64603 11.9965 6.64603 9.0625C6.64603 6.12849 9.05389 3.75 12.0241 3.75C14.9944 3.75 17.4023 6.12849 17.4023 9.0625ZM3.72897 22.5661C5.63439 19.7401 8.64116 17.9167 12.0241 17.9167C15.4071 17.9167 18.4139 19.7401 20.3193 22.5661C20.7367 23.1852 20.9455 23.4947 20.9214 23.8902C20.9027 24.1981 20.6984 24.575 20.4493 24.761C20.1295 25 19.6896 25 18.8097 25H5.23858C4.35874 25 3.91882 25 3.59895 24.761C3.34989 24.575 3.14557 24.1981 3.12686 23.8902C3.10284 23.4947 3.31155 23.1852 3.72897 22.5661Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgImagePlus(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.4167 2.49996H6.5C5.09987 2.49996 4.3998 2.49996 3.86502 2.77244C3.39462 3.01213 3.01217 3.39458 2.77248 3.86498C2.5 4.39976 2.5 5.09983 2.5 6.49996V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.1349C3.01217 16.6053 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H14.1667C14.9416 17.5 15.3291 17.5 15.647 17.4148C16.5098 17.1836 17.1836 16.5097 17.4148 15.647C17.5 15.3291 17.5 14.9416 17.5 14.1666M15.8333 6.66663V1.66663M13.3333 4.16663H18.3333M8.75 7.08329C8.75 8.00377 8.00381 8.74996 7.08333 8.74996C6.16286 8.74996 5.41667 8.00377 5.41667 7.08329C5.41667 6.16282 6.16286 5.41663 7.08333 5.41663C8.00381 5.41663 8.75 6.16282 8.75 7.08329ZM12.4917 9.93175L5.44262 16.34C5.04614 16.7004 4.84789 16.8807 4.83036 17.0368C4.81516 17.1721 4.86704 17.3063 4.96932 17.3962C5.08732 17.5 5.35523 17.5 5.89107 17.5H13.7133C14.9126 17.5 15.5123 17.5 15.9833 17.2985C16.5745 17.0455 17.0456 16.5745 17.2985 15.9832C17.5 15.5122 17.5 14.9126 17.5 13.7133C17.5 13.3098 17.5 13.108 17.4559 12.9201C17.4004 12.6839 17.2941 12.4628 17.1444 12.272C17.0252 12.1201 16.8677 11.9941 16.5526 11.742L14.2215 9.87718C13.9062 9.62488 13.7485 9.49874 13.5748 9.45422C13.4218 9.41498 13.2607 9.42006 13.1104 9.46887C12.94 9.52424 12.7905 9.66008 12.4917 9.93175Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgBarbell(props: SvgProps) {
  return (
    <svg
      width="28"
      height="17"
      viewBox="0 0 28 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="path-1-inside-1_59_6129" fill={props.tint}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 1.75C3 0.783502 3.7835 0 4.75 0H6.75C7.7165 0 8.5 0.783502 8.5 1.75V7.25H19V1.75C19 0.783502 19.7835 0 20.75 0H22.75C23.7165 0 24.5 0.783502 24.5 1.75V3H25.75C26.7165 3 27.5 3.7835 27.5 4.75V11.75C27.5 12.7165 26.7165 13.5 25.75 13.5H24.5V14.75C24.5 15.7165 23.7165 16.5 22.75 16.5H20.75C19.7835 16.5 19 15.7165 19 14.75V8.75H8.5V14.75C8.5 15.7165 7.7165 16.5 6.75 16.5H4.75C3.7835 16.5 3 15.7165 3 14.75V13.5H1.75C0.783502 13.5 0 12.7165 0 11.75V4.75C0 3.7835 0.783502 3 1.75 3H3V1.75ZM3 4.5V12H1.75C1.61193 12 1.5 11.8881 1.5 11.75V4.75C1.5 4.61193 1.61193 4.5 1.75 4.5H3ZM4.5 14.75V13.5V12.75V3.75V3V1.75C4.5 1.61193 4.61193 1.5 4.75 1.5H6.75C6.88807 1.5 7 1.61193 7 1.75V14.75C7 14.8881 6.88807 15 6.75 15H4.75C4.61193 15 4.5 14.8881 4.5 14.75ZM23 13.5V12.75V3.75V3V1.75C23 1.61193 22.8881 1.5 22.75 1.5H20.75C20.6119 1.5 20.5 1.61193 20.5 1.75V14.75C20.5 14.8881 20.6119 15 20.75 15H22.75C22.8881 15 23 14.8881 23 14.75V13.5ZM24.5 12H25.75C25.8881 12 26 11.8881 26 11.75V4.75C26 4.61193 25.8881 4.5 25.75 4.5H24.5V12Z"
        />
      </mask>
      <path
        d="M8.5 7.25H7V8.75H8.5V7.25ZM19 7.25V8.75H20.5V7.25H19ZM24.5 3H23V4.5H24.5V3ZM24.5 13.5V12H23V13.5H24.5ZM19 8.75H20.5V7.25H19V8.75ZM8.5 8.75V7.25H7V8.75H8.5ZM3 13.5H4.5V12H3V13.5ZM3 3V4.5H4.5V3H3ZM3 12V13.5H4.5V12H3ZM3 4.5H4.5V3H3V4.5ZM24.5 12H23V13.5H24.5V12ZM24.5 4.5V3H23V4.5H24.5ZM4.75 -1.5C2.95507 -1.5 1.5 -0.0449257 1.5 1.75H4.5C4.5 1.61193 4.61193 1.5 4.75 1.5V-1.5ZM6.75 -1.5H4.75V1.5H6.75V-1.5ZM10 1.75C10 -0.0449252 8.54493 -1.5 6.75 -1.5V1.5C6.88807 1.5 7 1.61193 7 1.75H10ZM10 7.25V1.75H7V7.25H10ZM8.5 8.75H19V5.75H8.5V8.75ZM17.5 1.75V7.25H20.5V1.75H17.5ZM20.75 -1.5C18.9551 -1.5 17.5 -0.0449261 17.5 1.75H20.5C20.5 1.61193 20.6119 1.5 20.75 1.5V-1.5ZM22.75 -1.5H20.75V1.5H22.75V-1.5ZM26 1.75C26 -0.0449247 24.5449 -1.5 22.75 -1.5V1.5C22.8881 1.5 23 1.61193 23 1.75H26ZM26 3V1.75H23V3H26ZM25.75 1.5H24.5V4.5H25.75V1.5ZM29 4.75C29 2.95508 27.5449 1.5 25.75 1.5V4.5C25.8881 4.5 26 4.61193 26 4.75H29ZM29 11.75V4.75H26V11.75H29ZM25.75 15C27.5449 15 29 13.5449 29 11.75H26C26 11.8881 25.8881 12 25.75 12V15ZM24.5 15H25.75V12H24.5V15ZM26 14.75V13.5H23V14.75H26ZM22.75 18C24.5449 18 26 16.5449 26 14.75H23C23 14.8881 22.8881 15 22.75 15V18ZM20.75 18H22.75V15H20.75V18ZM17.5 14.75C17.5 16.5449 18.9551 18 20.75 18V15C20.6119 15 20.5 14.8881 20.5 14.75H17.5ZM17.5 8.75V14.75H20.5V8.75H17.5ZM19 7.25H8.5V10.25H19V7.25ZM10 14.75V8.75H7V14.75H10ZM6.75 18C8.54493 18 10 16.5449 10 14.75H7C7 14.8881 6.88807 15 6.75 15V18ZM4.75 18H6.75V15H4.75V18ZM1.5 14.75C1.5 16.5449 2.95507 18 4.75 18V15C4.61193 15 4.5 14.8881 4.5 14.75H1.5ZM1.5 13.5V14.75H4.5V13.5H1.5ZM1.75 15H3V12H1.75V15ZM-1.5 11.75C-1.5 13.5449 -0.0449256 15 1.75 15V12C1.61193 12 1.5 11.8881 1.5 11.75H-1.5ZM-1.5 4.75V11.75H1.5V4.75H-1.5ZM1.75 1.5C-0.0449252 1.5 -1.5 2.95507 -1.5 4.75H1.5C1.5 4.61193 1.61193 4.5 1.75 4.5V1.5ZM3 1.5H1.75V4.5H3V1.5ZM1.5 1.75V3H4.5V1.75H1.5ZM4.5 12V4.5H1.5V12H4.5ZM1.75 13.5H3V10.5H1.75V13.5ZM0 11.75C0 12.7165 0.783501 13.5 1.75 13.5V10.5C2.44036 10.5 3 11.0596 3 11.75H0ZM0 4.75V11.75H3V4.75H0ZM1.75 3C0.783501 3 0 3.7835 0 4.75H3C3 5.44036 2.44036 6 1.75 6V3ZM3 3H1.75V6H3V3ZM3 13.5V14.75H6V13.5H3ZM3 12.75V13.5H6V12.75H3ZM3 3.75V12.75H6V3.75H3ZM3 3V3.75H6V3H3ZM3 1.75V3H6V1.75H3ZM4.75 0C3.7835 0 3 0.783501 3 1.75H6C6 2.44036 5.44036 3 4.75 3V0ZM6.75 0H4.75V3H6.75V0ZM8.5 1.75C8.5 0.783501 7.7165 0 6.75 0V3C6.05964 3 5.5 2.44036 5.5 1.75H8.5ZM8.5 14.75V1.75H5.5V14.75H8.5ZM6.75 16.5C7.7165 16.5 8.5 15.7165 8.5 14.75H5.5C5.5 14.0596 6.05964 13.5 6.75 13.5V16.5ZM4.75 16.5H6.75V13.5H4.75V16.5ZM3 14.75C3 15.7165 3.7835 16.5 4.75 16.5V13.5C5.44036 13.5 6 14.0596 6 14.75H3ZM21.5 12.75V13.5H24.5V12.75H21.5ZM21.5 3.75V12.75H24.5V3.75H21.5ZM21.5 3V3.75H24.5V3H21.5ZM21.5 1.75V3H24.5V1.75H21.5ZM22.75 3C22.0596 3 21.5 2.44036 21.5 1.75H24.5C24.5 0.783501 23.7165 0 22.75 0V3ZM20.75 3H22.75V0H20.75V3ZM22 1.75C22 2.44036 21.4404 3 20.75 3V0C19.7835 0 19 0.783501 19 1.75H22ZM22 14.75V1.75H19V14.75H22ZM20.75 13.5C21.4404 13.5 22 14.0596 22 14.75H19C19 15.7165 19.7835 16.5 20.75 16.5V13.5ZM22.75 13.5H20.75V16.5H22.75V13.5ZM21.5 14.75C21.5 14.0596 22.0596 13.5 22.75 13.5V16.5C23.7165 16.5 24.5 15.7165 24.5 14.75H21.5ZM21.5 13.5V14.75H24.5V13.5H21.5ZM25.75 10.5H24.5V13.5H25.75V10.5ZM24.5 11.75C24.5 11.0596 25.0596 10.5 25.75 10.5V13.5C26.7165 13.5 27.5 12.7165 27.5 11.75H24.5ZM24.5 4.75V11.75H27.5V4.75H24.5ZM25.75 6C25.0596 6 24.5 5.44036 24.5 4.75H27.5C27.5 3.7835 26.7165 3 25.75 3V6ZM24.5 6H25.75V3H24.5V6ZM26 12V4.5H23V12H26Z"
        fill={props.tint}
        mask="url(#path-1-inside-1_59_6129)"
      />
    </svg>
  );
}

function SvgPlus(props: SvgProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 1V13M1 7H13"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgPlusSmall(props: SvgProps) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 1.5V10.5M1.5 6H10.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgActivity(props: SvgProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.74921 18.5235L17.9119 20.2939C18.7218 20.395 19.3299 21.0838 19.3299 21.8999C19.3299 22.8733 18.4763 23.627 17.5106 23.5063L3.34791 21.7359C2.53799 21.6348 1.92993 20.946 1.92993 20.1299C1.92993 19.1565 2.78309 18.4028 3.74921 18.5235Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M4.10693 21.8305V28.0836"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.1553 23.4622V28.084"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M2.08203 15.9149C2.08203 14.4133 3.29937 13.196 4.80095 13.196C6.30254 13.196 7.51987 14.4133 7.51987 15.9149C7.51987 17.4165 6.30254 18.6338 4.80095 18.6338C3.29937 18.6338 2.08203 17.4165 2.08203 15.9149Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.4392 12.3781V16.6651V15.4759L23.0001 16.546C24.6326 16.7499 25.8581 18.1381 25.8581 19.7832V26.4527C25.8581 27.3536 25.1277 28.084 24.2269 28.084C23.326 28.084 22.5956 27.3536 22.5956 26.4527V20.8791L9.27544 19.2139C8.18698 19.0777 7.37012 18.1528 7.37012 17.0558C7.37012 15.7475 8.51649 14.7353 9.81498 14.8976L11.1767 15.0676V12.3777"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M7.91211 6.76881C7.91211 4.0662 10.1033 1.875 12.8059 1.875C15.5085 1.875 17.6997 4.0662 17.6997 6.76881C17.6997 9.47142 15.5085 11.6626 12.8059 11.6626C10.1033 11.6626 7.91211 9.47142 7.91211 6.76881Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11.1748 6.76875C11.1748 5.86788 11.9052 5.13748 12.8061 5.13748C13.7069 5.13748 14.4373 5.86788 14.4373 6.76875C14.4373 7.66962 13.7069 8.40002 12.8061 8.40002C11.9052 8.40002 11.1748 7.66962 11.1748 6.76875Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 28.084H28.0842"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgEmptyGraph(props: SvgProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="3" y="17" width="6" height="8" rx="1" stroke={props.tint} strokeWidth="1.5" />
      <rect x="12" y="11" width="6" height="14" rx="1" stroke={props.tint} strokeWidth="1.5" />
      <rect x="21" y="5" width="6" height="20" rx="1" stroke={props.tint} strokeWidth="1.5" />
    </svg>
  );
}

function SvgDurationGraph(props: SvgProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 7.44531V18.6953H11.25V7.44531H7.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 10.1953C17.25 7.70572 17.25 3.69531 17.25 3.69531H13.5C13.5 3.69531 13.5 7.96981 13.5 12.0703"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 11.9453V18.6953H5.25V11.9453H1.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 22.4453C20.4853 22.4453 22.5 20.4306 22.5 17.9453C22.5 15.46 20.4853 13.4453 18 13.4453C15.5147 13.4453 13.5 15.46 13.5 17.9453C13.5 20.4306 15.5147 22.4453 18 22.4453Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M18 15.6953V17.9453H20.25"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgVolumeGraph(props: SvgProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 7.44531V18.6953H11.25V7.44531H7.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 10.1953C17.25 7.70572 17.25 3.69531 17.25 3.69531H13.5C13.5 3.69531 13.5 8.96981 13.5 13.0703"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 11.9453V18.6953H5.25V11.9453H1.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <rect
        x="13.3046"
        y="19.4585"
        width="2.625"
        height="4.5"
        rx="0.375"
        transform="rotate(-45 13.3046 19.4585)"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <rect
        x="17.6572"
        y="15.106"
        width="2.625"
        height="4.5"
        rx="0.375"
        transform="rotate(-45 17.6572 15.106)"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <line
        x1="17.1354"
        y1="18.5165"
        x2="18.7264"
        y2="16.9255"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}

function SvgSetsGraph(props: SvgProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 7.44531V18.6953H11.25V7.44531H7.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 10.1953C17.25 7.70572 17.25 3.69531 17.25 3.69531H13.5C13.5 3.69531 13.5 7.96981 13.5 12.0703"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 11.9453V18.6953H5.25V11.9453H1.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.4774 16.5646H22.5V14.542"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.7808 21.1407C20.1587 21.7633 19.3658 22.1875 18.5026 22.3595C17.6393 22.5315 16.7445 22.4436 15.9312 22.1069C15.1179 21.7702 14.4227 21.1999 13.9336 20.4681C13.4445 19.7362 13.1835 18.8758 13.1835 17.9956C13.1835 17.1154 13.4445 16.2549 13.9336 15.5231C14.4227 14.7913 15.1179 14.2209 15.9312 13.8843C16.7445 13.5476 17.6393 13.4597 18.5026 13.6317C19.3658 13.8037 20.1587 14.2278 20.7808 14.8505L22.0882 16.154"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgSetsPerMuscleGroupGraph(props: SvgProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.25 18.6953H1.5V3.69531"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.2508 7.44531L11.2508 13.4453L5.25079 8.94531L2 11.7898"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.4774 16.5646H22.5V14.542"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.7808 21.1407C20.1587 21.7633 19.3658 22.1875 18.5026 22.3595C17.6393 22.5315 16.7445 22.4436 15.9312 22.1069C15.1179 21.7702 14.4227 21.1999 13.9336 20.4681C13.4445 19.7362 13.1835 18.8758 13.1835 17.9956C13.1835 17.1154 13.4445 16.2549 13.9336 15.5231C14.4227 14.7913 15.1179 14.2209 15.9312 13.8843C16.7445 13.5476 17.6393 13.4597 18.5026 13.6317C19.3658 13.8037 20.1587 14.2278 20.7808 14.8505L22.0882 16.154"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgClock(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10 5.625V10H14.375"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgCalendar(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4 7.4H10.2H3M13.4 1.5V3.2M7 1.5V3.2M6.84 17H13.56C14.9041 17 15.5762 17 16.0896 16.7384C16.5412 16.5083 16.9083 16.1412 17.1384 15.6896C17.4 15.1762 17.4 14.5041 17.4 13.16V6.44C17.4 5.09587 17.4 4.42381 17.1384 3.91042C16.9083 3.45883 16.5412 3.09168 16.0896 2.86158C15.5762 2.6 14.9041 2.6 13.56 2.6H6.84C5.49587 2.6 4.82381 2.6 4.31042 2.86158C3.85883 3.09168 3.49168 3.45883 3.26158 3.91042C3 4.42381 3 5.09587 3 6.44V13.16C3 14.5041 3 15.1762 3.26158 15.6896C3.49168 16.1412 3.85883 16.5083 4.31042 16.7384C4.82381 17 5.49587 17 6.84 17Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgNotepad(props: SvgProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25 15H18.75"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 18.75H18.75"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6.5625 4.6875H23.4375C23.6861 4.6875 23.9246 4.78627 24.1004 4.96209C24.2762 5.1379 24.375 5.37636 24.375 5.625V23.4375C24.375 24.1834 24.0787 24.8988 23.5512 25.4262C23.0238 25.9537 22.3084 26.25 21.5625 26.25H8.4375C7.69158 26.25 6.97621 25.9537 6.44876 25.4262C5.92132 24.8988 5.625 24.1834 5.625 23.4375V5.625C5.625 5.37636 5.72377 5.1379 5.89959 4.96209C6.0754 4.78627 6.31386 4.6875 6.5625 4.6875V4.6875Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 2.8125V6.5625"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M15 2.8125V6.5625"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20.625 2.8125V6.5625"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgTemplate(props: SvgProps) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.33337 2.08333H3.99078C3.49814 2.08333 3.25182 2.08333 3.06366 2.17921C2.89815 2.26354 2.76358 2.39811 2.67925 2.56362C2.58337 2.75178 2.58337 2.9981 2.58337 3.49074V6.83333C2.58337 7.32597 2.58337 7.57229 2.67925 7.76045C2.76358 7.92597 2.89815 8.06053 3.06366 8.14487C3.25182 8.24074 3.49814 8.24074 3.99078 8.24074H7.33337C7.82601 8.24074 8.07233 8.24074 8.2605 8.14487C8.42601 8.06053 8.56057 7.92597 8.64491 7.76045C8.74078 7.57229 8.74078 7.32597 8.74078 6.83333V3.49074C8.74078 2.9981 8.74078 2.75178 8.64491 2.56362C8.56057 2.39811 8.42601 2.26354 8.2605 2.17921C8.07233 2.08333 7.82601 2.08333 7.33337 2.08333Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0093 2.08333H13.6667C13.1741 2.08333 12.9277 2.08333 12.7396 2.17921C12.5741 2.26354 12.4395 2.39811 12.3552 2.56362C12.2593 2.75178 12.2593 2.9981 12.2593 3.49074V6.83333C12.2593 7.32597 12.2593 7.57229 12.3552 7.76045C12.4395 7.92597 12.5741 8.06053 12.7396 8.14487C12.9277 8.24074 13.1741 8.24074 13.6667 8.24074H17.0093C17.5019 8.24074 17.7483 8.24074 17.9364 8.14487C18.1019 8.06053 18.2365 7.92597 18.3208 7.76045C18.4167 7.57229 18.4167 7.32597 18.4167 6.83333V3.49074C18.4167 2.9981 18.4167 2.75178 18.3208 2.56362C18.2365 2.39811 18.1019 2.26354 17.9364 2.17921C17.7483 2.08333 17.5019 2.08333 17.0093 2.08333Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0093 11.7593H13.6667C13.1741 11.7593 12.9277 11.7593 12.7396 11.8551C12.5741 11.9395 12.4395 12.074 12.3552 12.2395C12.2593 12.4277 12.2593 12.674 12.2593 13.1667V16.5093C12.2593 17.0019 12.2593 17.2482 12.3552 17.4364C12.4395 17.6019 12.5741 17.7365 12.7396 17.8208C12.9277 17.9167 13.1741 17.9167 13.6667 17.9167H17.0093C17.5019 17.9167 17.7483 17.9167 17.9364 17.8208C18.1019 17.7365 18.2365 17.6019 18.3208 17.4364C18.4167 17.2482 18.4167 17.0019 18.4167 16.5093V13.1667C18.4167 12.674 18.4167 12.4277 18.3208 12.2395C18.2365 12.074 18.1019 11.9395 17.9364 11.8551C17.7483 11.7593 17.5019 11.7593 17.0093 11.7593Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33337 11.7593H3.99078C3.49814 11.7593 3.25182 11.7593 3.06366 11.8551C2.89815 11.9395 2.76358 12.074 2.67925 12.2395C2.58337 12.4277 2.58337 12.674 2.58337 13.1667V16.5093C2.58337 17.0019 2.58337 17.2482 2.67925 17.4364C2.76358 17.6019 2.89815 17.7365 3.06366 17.8208C3.25182 17.9167 3.49814 17.9167 3.99078 17.9167H7.33337C7.82601 17.9167 8.07233 17.9167 8.2605 17.8208C8.42601 17.7365 8.56057 17.6019 8.64491 17.4364C8.74078 17.2482 8.74078 17.0019 8.74078 16.5093V13.1667C8.74078 12.674 8.74078 12.4277 8.64491 12.2395C8.56057 12.074 8.42601 11.9395 8.2605 11.8551C8.07233 11.7593 7.82601 11.7593 7.33337 11.7593Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgComment(props: SvgProps) {
  return (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.9996 9.5C19.9996 14.1944 16.194 18 11.4996 18C10.4228 18 9.39283 17.7998 8.44478 17.4345C8.27145 17.3678 8.18478 17.3344 8.11586 17.3185C8.04807 17.3029 7.999 17.2963 7.92949 17.2937C7.85881 17.291 7.78127 17.299 7.62619 17.315L2.50517 17.8444C2.01692 17.8948 1.7728 17.9201 1.6288 17.8322C1.50337 17.7557 1.41794 17.6279 1.3952 17.4828C1.36909 17.3161 1.48575 17.1002 1.71906 16.6684L3.35472 13.6408C3.48942 13.3915 3.55677 13.2668 3.58728 13.1469C3.6174 13.0286 3.62469 12.9432 3.61505 12.8214C3.60529 12.6981 3.55119 12.5376 3.443 12.2166C3.15547 11.3636 2.99962 10.45 2.99962 9.5C2.99962 4.80558 6.8052 1 11.4996 1C16.194 1 19.9996 4.80558 19.9996 9.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgSortArrow(props: SvgProps) {
  return (
    <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 5L5.1247 0.780869C4.91116 0.513946 4.80439 0.380484 4.6754 0.332164C4.5623 0.289799 4.4377 0.289799 4.3246 0.332164C4.19561 0.380484 4.08884 0.513946 3.87531 0.780869L0.5 5"
        fill="#6C737F"
      />
      <path
        d="M8.5 5L5.1247 0.780869C4.91116 0.513946 4.80439 0.380484 4.6754 0.332164C4.5623 0.289799 4.4377 0.289799 4.3246 0.332164C4.19561 0.380484 4.08884 0.513946 3.87531 0.780869L0.5 5"
        fill={props.tint}
      />
      <path
        d="M8.5 5L5.1247 0.780869C4.91116 0.513946 4.80439 0.380484 4.6754 0.332164C4.5623 0.289799 4.4377 0.289799 4.3246 0.332164C4.19561 0.380484 4.08884 0.513946 3.87531 0.780869L0.5 5"
        fill={props.tint}
      />
    </svg>
  );
}

function SvgSpiderWeb(props: SvgProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.403 7.94625L10.3173 1.73928C10.1907 1.64257 10.0163 1.64257 9.89045 1.73928L1.80475 7.94625C1.68577 8.03799 1.63732 8.19563 1.68445 8.33836L4.77332 17.675C4.82111 17.8197 4.95558 17.9167 5.10719 17.9167H15.1018C15.2531 17.9167 15.3879 17.8194 15.4357 17.675L18.5246 8.33836C18.5704 8.19496 18.5219 8.03799 18.403 7.94625Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14.3682 9.55894L10.1756 6.45545C10.11 6.4071 10.0195 6.4071 9.95427 6.45545L5.76168 9.55894C5.69999 9.60481 5.67487 9.68363 5.69931 9.755L7.30094 14.4233C7.32572 14.4957 7.39545 14.5442 7.47406 14.5442H12.6565C12.7349 14.5442 12.8048 14.4955 12.8296 14.4233L14.4312 9.755C14.455 9.6833 14.4299 9.60481 14.3682 9.55894Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M10.0651 10.6902V1.66675" stroke={props.tint} strokeWidth="1.5" />
      <path d="M4.91666 17.8473L10.0726 10.6793" stroke={props.tint} strokeWidth="1.5" />
      <path d="M1.69246 8.13355L10.0663 10.6825" stroke={props.tint} strokeWidth="1.5" />
      <path d="M18.5228 8.1291L10.0608 10.6827" stroke={props.tint} strokeWidth="1.5" />
      <path d="M15.2865 17.8582L10.0672 10.6804" stroke={props.tint} strokeWidth="1.5" />
    </svg>
  );
}
function SvgMuscleGroupBody(props: SvgProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2086 5.41664C11.4742 5.41664 12.5003 4.39061 12.5003 3.12494C12.5003 1.85928 11.4742 0.833252 10.2086 0.833252C8.9429 0.833252 7.91687 1.85928 7.91687 3.12494C7.91687 4.39061 8.9429 5.41664 10.2086 5.41664Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9354 10.7028L14.736 12.8757C14.9212 13.0298 15.1573 13.1092 15.3979 13.0982C15.6386 13.0872 15.8664 12.9867 16.0368 12.8163C16.2071 12.646 16.3076 12.4181 16.3186 12.1775C16.3296 11.9368 16.2503 11.7008 16.0961 11.5156L12.9092 7.41917C12.7606 7.26914 12.5839 7.14995 12.3892 7.06846C12.1944 6.98697 11.9855 6.94479 11.7744 6.94434H7.91139C7.48293 6.94663 7.07252 7.11716 6.76858 7.41917L3.5816 11.5156C3.41566 11.6998 3.32692 11.9408 3.33374 12.1886C3.34056 12.4364 3.44243 12.6721 3.61825 12.8469C3.79408 13.0217 4.03038 13.1222 4.27825 13.1276C4.52611 13.1329 4.76654 13.0427 4.94975 12.8757L7.75043 10.7028L5.51311 17.7528C5.45921 17.868 5.42852 17.9927 5.42281 18.1198C5.4171 18.2468 5.43647 18.3738 5.47981 18.4933C5.52316 18.6129 5.58963 18.7228 5.67543 18.8166C5.76123 18.9105 5.86469 18.9866 5.97989 19.0405C6.09509 19.0944 6.21977 19.1251 6.34683 19.1308C6.47389 19.1365 6.60082 19.1171 6.72039 19.0738C6.83997 19.0304 6.94983 18.964 7.04371 18.8782C7.13759 18.7924 7.21366 18.6889 7.26756 18.5737L9.84289 14.5175L12.4182 18.5737C12.4685 18.6939 12.5427 18.8027 12.6361 18.8936C12.7296 18.9844 12.8405 19.0554 12.9621 19.1022C13.0837 19.149 13.2136 19.1707 13.3438 19.1661C13.4741 19.1614 13.602 19.1304 13.72 19.075C13.8379 19.0195 13.9434 18.9408 14.0301 18.8435C14.1168 18.7462 14.183 18.6323 14.2245 18.5088C14.2661 18.3853 14.2822 18.2546 14.2719 18.1247C14.2616 17.9948 14.2251 17.8683 14.1646 17.7528L11.9354 10.7028Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgRoutineSummaryButtonIcon(props: SvgProps) {
  return (
    <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3332 0.833328L11.776 7.39052C11.446 7.72053 11.281 7.88554 11.0907 7.94736C10.9233 8.00175 10.743 8.00175 10.5757 7.94736C10.3854 7.88554 10.2204 7.72053 9.89036 7.39052L7.60931 5.10947C7.2793 4.77946 7.11429 4.61445 6.92402 4.55263C6.75665 4.49824 6.57636 4.49824 6.40899 4.55263C6.21872 4.61445 6.05371 4.77946 5.72369 5.10947L1.6665 9.16666M18.3332 0.833328H12.4998M18.3332 0.833328V6.66666"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgProgramSummaryToggle(props: SvgProps) {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 12L12 7L7 2"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M2 12L7 7L2 2"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgImport(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5 17.5H2.5M15 9.16667L10 14.1667M10 14.1667L5 9.16667M10 14.1667V2.5"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgTransferToCoach(props: SvgProps) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99967 11.9167H13.7497C14.9126 11.9167 15.4941 11.9167 15.9673 12.0602C17.0326 12.3834 17.8663 13.217 18.1895 14.2824C18.333 14.7555 18.333 15.337 18.333 16.5M4.16699 16.5L6.66699 14M6.66699 14L4.16699 11.5M6.66699 14H1.66699M7.91634 5.25C7.91634 7.32107 9.59527 9 11.6663 9C13.7374 9 15.4163 7.32107 15.4163 5.25C15.4163 3.17893 13.7374 1.5 11.6663 1.5C9.59527 1.5 7.91634 3.17893 7.91634 5.25Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgTransferFromCoach(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8337 17.5L18.3337 15M18.3337 15L15.8337 12.5M18.3337 15H13.3337M10.0003 12.9167H6.25033C5.08736 12.9167 4.50587 12.9167 4.03271 13.0602C2.96737 13.3834 2.13369 14.217 1.81053 15.2824C1.66699 15.7555 1.66699 16.337 1.66699 17.5M12.0837 6.25C12.0837 8.32107 10.4047 10 8.33366 10C6.26259 10 4.58366 8.32107 4.58366 6.25C4.58366 4.17893 6.26259 2.5 8.33366 2.5C10.4047 2.5 12.0837 4.17893 12.0837 6.25Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgLockLight(props: SvgProps) {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.675 17.5709C14.675 18.0841 14.259 18.5001 13.7458 18.5001H2.25442C1.74122 18.5001 1.3252 18.0841 1.3252 17.5709V8.55593C1.3252 8.04274 1.74122 7.62671 2.25442 7.62671H13.7458C14.259 7.62671 14.675 8.04274 14.675 8.55593V17.5709Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
      />
      <path
        d="M4.18945 7.6226L4.18946 5.31103C4.18946 3.2064 5.89586 1.5 8.00049 1.5C10.1051 1.5 11.8115 3.2064 11.8115 5.31103L11.8115 7.6226"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
      />
      <line x1="8" y1="11.0632" x2="8" y2="15.0632" stroke={props.tint} strokeWidth="1.5" />
    </svg>
  );
}

function SvgTeam(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 18.75C9.15685 18.75 10.5 17.4069 10.5 15.75C10.5 14.0931 9.15685 12.75 7.5 12.75C5.84315 12.75 4.5 14.0931 4.5 15.75C4.5 17.4069 5.84315 18.75 7.5 18.75Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M3 21C3.52395 20.3014 4.20336 19.7344 4.98442 19.3438C5.76549 18.9533 6.62675 18.75 7.5 18.75C8.37325 18.75 9.23451 18.9533 10.0156 19.3438C10.7966 19.7344 11.476 20.3014 12 21"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9C9.15685 9 10.5 7.65685 10.5 6C10.5 4.34315 9.15685 3 7.5 3C5.84315 3 4.5 4.34315 4.5 6C4.5 7.65685 5.84315 9 7.5 9Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M3 11.25C3.52395 10.5514 4.20336 9.98438 4.98442 9.59385C5.76549 9.20332 6.62675 9 7.5 9C8.37325 9 9.23451 9.20332 10.0156 9.59385C10.7966 9.98438 11.476 10.5514 12 11.25"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 18.75C18.1569 18.75 19.5 17.4069 19.5 15.75C19.5 14.0931 18.1569 12.75 16.5 12.75C14.8431 12.75 13.5 14.0931 13.5 15.75C13.5 17.4069 14.8431 18.75 16.5 18.75Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 21C12.524 20.3014 13.2034 19.7344 13.9844 19.3438C14.7655 18.9533 15.6267 18.75 16.5 18.75C17.3733 18.75 18.2345 18.9533 19.0156 19.3438C19.7966 19.7344 20.476 20.3014 21 21"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 9C18.1569 9 19.5 7.65685 19.5 6C19.5 4.34315 18.1569 3 16.5 3C14.8431 3 13.5 4.34315 13.5 6C13.5 7.65685 14.8431 9 16.5 9Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.25C12.524 10.5514 13.2034 9.98438 13.9844 9.59385C14.7655 9.20332 15.6267 9 16.5 9C17.3733 9 18.2345 9.20332 19.0156 9.59385C19.7966 9.98438 20.476 10.5514 21 11.25"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgCrossSmall(props: SvgProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 3L6 6M6 6L9 9M6 6L3 9M6 6L9 3"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgNotification(props: SvgProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 23.8086V25C12.5 26.3797 13.6203 27.5 15 27.5C16.3797 27.5 17.5 26.3797 17.5 25V23.8086"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
        strokeLinecap="round"
      />
      <path
        d="M16.875 3.75C20.6244 4.64466 23.4133 8.26099 23.4133 12.2961V18.5857C23.4153 19.4567 23.6827 20.3064 24.1797 21.0205L25.6423 22.9508C25.8918 23.2801 25.657 23.7528 25.2438 23.7528H4.69608C4.29436 23.7528 4.05666 23.303 4.28297 22.9711L5.6129 21.0205C6.1099 20.3064 6.37735 19.4567 6.37935 18.5857L6.38102 12.2961C6.38102 8.26099 9.37556 4.64466 13.125 3.75"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.875 3.75C16.875 3.19082 16.875 2.94312 16.875 2.94312C16.875 2.00871 16.0348 1.25 15 1.25C13.9652 1.25 13.125 2.00871 13.125 2.94312L13.125 3.75"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeMiterlimit="13.33"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SvgUsers(props: SvgProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.375 23.4375C11.4461 23.4375 13.125 21.7586 13.125 19.6875C13.125 17.6164 11.4461 15.9375 9.375 15.9375C7.30393 15.9375 5.625 17.6164 5.625 19.6875C5.625 21.7586 7.30393 23.4375 9.375 23.4375Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 26.25C4.40494 25.3767 5.2542 24.668 6.23053 24.1798C7.20686 23.6916 8.28343 23.4375 9.375 23.4375C10.4666 23.4375 11.5431 23.6916 12.5195 24.1798C13.4958 24.668 14.3451 25.3767 15 26.25"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 11.25C11.4461 11.25 13.125 9.57107 13.125 7.5C13.125 5.42893 11.4461 3.75 9.375 3.75C7.30393 3.75 5.625 5.42893 5.625 7.5C5.625 9.57107 7.30393 11.25 9.375 11.25Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 14.0625C4.40494 13.1892 5.2542 12.4805 6.23053 11.9923C7.20686 11.5041 8.28343 11.25 9.375 11.25C10.4666 11.25 11.5431 11.5041 12.5195 11.9923C13.4958 12.4805 14.3451 13.1892 15 14.0625"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.625 23.4375C22.6961 23.4375 24.375 21.7586 24.375 19.6875C24.375 17.6164 22.6961 15.9375 20.625 15.9375C18.5539 15.9375 16.875 17.6164 16.875 19.6875C16.875 21.7586 18.5539 23.4375 20.625 23.4375Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 26.25C15.6549 25.3767 16.5042 24.668 17.4805 24.1798C18.4569 23.6916 19.5334 23.4375 20.625 23.4375C21.7166 23.4375 22.7931 23.6916 23.7695 24.1798C24.7458 24.668 25.5951 25.3767 26.25 26.25"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.625 11.25C22.6961 11.25 24.375 9.57107 24.375 7.5C24.375 5.42893 22.6961 3.75 20.625 3.75C18.5539 3.75 16.875 5.42893 16.875 7.5C16.875 9.57107 18.5539 11.25 20.625 11.25Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 14.0625C15.6549 13.1892 16.5042 12.4805 17.4805 11.9923C18.4569 11.5041 19.5334 11.25 20.625 11.25C21.7166 11.25 22.7931 11.5041 23.7695 11.9923C24.7458 12.4805 25.5951 13.1892 26.25 14.0625"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function SvgCompare(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 2.5V17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgBrush(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.125 8.74915H16.875"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03125 11.8744H4.375C4.04348 11.8744 3.72554 11.7427 3.49112 11.5083C3.2567 11.2739 3.125 10.9559 3.125 10.6244V4.99939C3.125 4.33635 3.38839 3.70046 3.85723 3.23162C4.32607 2.76278 4.96196 2.49939 5.625 2.49939H16.875V10.6244C16.875 10.9559 16.7433 11.2739 16.5089 11.5083C16.2745 11.7427 15.9565 11.8744 15.625 11.8744H11.9687C11.8796 11.8747 11.7915 11.894 11.7104 11.9311C11.6293 11.9683 11.5571 12.0223 11.4987 12.0897C11.4402 12.157 11.3968 12.2361 11.3715 12.3216C11.3461 12.4071 11.3393 12.497 11.3516 12.5853L11.875 16.2494C11.875 16.7467 11.6775 17.2236 11.3258 17.5752C10.9742 17.9268 10.4973 18.1244 10 18.1244C9.50272 18.1244 9.02581 17.9268 8.67417 17.5752C8.32254 17.2236 8.125 16.7467 8.125 16.2494L8.64844 12.5853C8.6607 12.497 8.65392 12.4071 8.62855 12.3216C8.60317 12.2361 8.5598 12.157 8.50134 12.0897C8.44288 12.0223 8.37068 11.9683 8.2896 11.9311C8.20852 11.894 8.12043 11.8747 8.03125 11.8744V11.8744Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.376 2.49939V6.24939"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgExternalLink(props: SvgProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5 7.50001L17.5 2.50001M17.5 2.50001H12.5M17.5 2.50001L10 10M8.33333 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5V11.6667"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgPictureFrame(props: SvgProps) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 2.5H7C5.59987 2.5 4.8998 2.5 4.36502 2.77248C3.89462 3.01217 3.51217 3.39462 3.27248 3.86502C3 4.3998 3 5.09987 3 6.5V13.5C3 14.9001 3 15.6002 3.27248 16.135C3.51217 16.6054 3.89462 16.9878 4.36502 17.2275C4.8998 17.5 5.59987 17.5 7 17.5H14C15.4001 17.5 16.1002 17.5 16.635 17.2275C17.1054 16.9878 17.4878 16.6054 17.7275 16.135C18 15.6002 18 14.9001 18 13.5V6.5C18 5.09987 18 4.3998 17.7275 3.86502C17.4878 3.39462 17.1054 3.01217 16.635 2.77248C16.1002 2.5 15.4001 2.5 14 2.5Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SvgPicturePlus(props: SvgProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M19 8V2M16 5H22M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96318 20.8755C6.10478 21 6.42628 21 7.06928 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5041C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z"
        stroke={props.tint}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
